<template>
<section class="flex flex-col items-center justify-center body-font text-gray-600 bg-white h-screen">
    <div class="my-10">
      <div class="w-full md:w-96 bg-white mx-auto rounded-xl">
        <div class="text-xl font-medium p-6">Your Cart</div>
        <ul>
          <li class="border-t border-gray-200 p-6">
            <a href="#" class="flex gap-4">
              <div
                class="w-24 h-24 flex-autoCustom border border-gray-200 rounded-md"
              >
                <img
                  class="rounded-md"
                  :src="`${publicPath}unsplash.jpeg`"
                  alt=""
                />
              </div>
              <div class="flex flex-col space-y-4">
                <span>A right media mix can make the difference</span>
                <span class="text-sm font-semibold">$600,39</span>
              </div>
            </a>
          </li>
          <li class="border-t border-gray-200 p-6">
            <a href="#" class="flex gap-4">
              <div
                class="w-24 h-24 flex-autoCustom border border-gray-200 rounded-md"
              >
                <img
                  class="rounded-md"
                  :src="`${publicPath}unsplash.jpeg`"
                  alt=""
                />
              </div>
              <div class="flex flex-col space-y-4">
                <span>Importance of the custom logo design</span>
                <span class="text-sm font-semibold">$300,39</span>
              </div>
            </a>
          </li>
          <li class="border-t border-gray-200 p-6">
            <a href="#" class="flex gap-4">
              <div
                class="w-24 h-24 flex-autoCustom border border-gray-200 rounded-md"
              >
                <img
                  class="rounded-md"
                  :src="`${publicPath}unsplash.jpeg`"
                  alt=""
                />
              </div>
              <div class="flex flex-col space-y-4">
                <span>Importance of the custom logo design</span>
                <span class="text-sm font-semibold">$600,39</span>
              </div>
            </a>
          </li>
        </ul>
        <div class="text-center border-t border-gray-200 px-6 py-8 space-y-4">
          <div>Total Price: <strong>$1.501,17</strong></div>
          <button
            type="button"
            class="inline-flex items-center px-6 py-4 border border-transparent shadow-sm text-sm font-semibold rounded-md uppercase transition-all text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Proceed The Checkout
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="-mr-1 ml-3 h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div class="my-10">
      <div class="max-w-screen-xl mx-auto p-4 sm:p-10 bg-white">
        <div
          class="relative z-10 flex items-center justify-between pb-6 border-b border-gray-200"
        >
          <h1
            class="text-2xl sm:text-4xl font-extrabold tracking-tight text-gray-900"
          >
            Filter
          </h1>

          <div class="flex items-center">
            <button class="relative text-sm focus:outline-none dropdown">
              <div
                class="flex items-center justify-between w-40 h-10 px-3 rounded hover:bg-gray-100"
              >
                <span class="font-medium"> Popular </span>
                <svg
                  class="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <div
                class="absolute z-10 flex-col items-start hidden w-full bg-white shadow-lg rounded dropdown-menu"
              >
                <a class="w-full px-4 py-2 text-left hover:bg-gray-200" href="#"
                  >Popular</a
                >
                <a class="w-full px-4 py-2 text-left hover:bg-gray-200" href="#"
                  >Featured</a
                >
                <a class="w-full px-4 py-2 text-left hover:bg-gray-200" href="#"
                  >Newest</a
                >
                <a class="w-full px-4 py-2 text-left hover:bg-gray-200" href="#"
                  >Lowest Price</a
                >
                <a class="w-full px-4 py-2 text-left hover:bg-gray-200" href="#"
                  >Highest Price</a
                >
              </div>
            </button>

            <button
              type="button"
              class="p-2 -m-2 ml-5 sm:ml-7 text-gray-400 hover:text-gray-500"
            >
              <span class="sr-only">View grid</span>
              <svg
                class="w-5 h-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                />
              </svg>
            </button>
            <button
              type="button"
              class="p-2 -m-2 ml-4 sm:ml-6 text-gray-400 hover:text-gray-500"
            >
              <span class="sr-only">Filters</span>
              <svg
                class="w-5 h-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </div>
        </div>
        <div class="mt-6">
          <div class="w-full md:w-96">
            <div class="py-6 border-b border-gray-300">
              <button
                type="button"
                class="flex items-center justify-between w-full text-gray-400 focus:outline-none"
              >
                <span class="font-medium text-gray-800">Product Type</span>
                <svg
                  class="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
              <div class="pt-6">
                <div class="space-y-6">
                  <div class="flex items-center">
                    <input
                      id="product-type-0"
                      name="product-type[]"
                      value="white"
                      checked
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="product-type-0"
                      class="flex items-center justify-between ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      <span>Clock</span>
                      <span
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gray-200 text-gray-800"
                      >
                        120
                      </span>
                    </label>
                  </div>

                  <div class="flex items-center">
                    <input
                      id="product-type-1"
                      name="product-type[]"
                      value="beige"
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="product-type-1"
                      class="flex items-center justify-between ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      <span>Television</span>
                      <span
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gray-200 text-gray-800"
                      >
                        50
                      </span>
                    </label>
                  </div>

                  <div class="flex items-center">
                    <input
                      id="product-type-2"
                      name="product-type[]"
                      value="blue"
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="product-type-2"
                      class="flex items-center justify-between ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      <span>Desk Mate</span>
                      <span
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gray-200 text-gray-800"
                      >
                        137
                      </span>
                    </label>
                  </div>

                  <div class="flex items-center">
                    <input
                      id="product-type-3"
                      name="product-type[]"
                      value="brown"
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="product-type-3"
                      class="flex items-center justify-between ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      <span>Mouse</span>
                      <span
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gray-200 text-gray-800"
                      >
                        99
                      </span>
                    </label>
                  </div>

                  <div class="flex items-center">
                    <input
                      id="product-type-4"
                      name="product-type[]"
                      value="green"
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="product-type-4"
                      class="flex items-center justify-between ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      <span>Laptop</span>
                      <span
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gray-200 text-gray-800"
                      >
                        359
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="py-6 border-b border-gray-300">
              <button
                type="button"
                class="flex items-center justify-between w-full text-gray-400 focus:outline-none"
              >
                <span class="font-medium text-gray-800">Color</span>
                <svg
                  class="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
              <div class="pt-6">
                <div class="grid grid-cols-4 gap-4">
                  <!-- Active: "ring-2 ring-indigo-500" -->
                  <label
                    class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-xs sm:text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer ring-2 ring-indigo-500"
                  >
                    <input
                      type="radio"
                      name="color-choice"
                      value="White"
                      class="sr-only"
                      aria-labelledby="color-choice-0-label"
                    />
                    <p id="color-choice-0-label">White</p>
                    <div
                      class="absolute -inset-px rounded-md pointer-events-none"
                      aria-hidden="true"
                    ></div>
                  </label>

                  <!-- Active: "ring-2 ring-indigo-500" -->
                  <label
                    class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-xs sm:text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer"
                  >
                    <input
                      type="radio"
                      name="color-choice"
                      value="Red"
                      class="sr-only"
                      aria-labelledby="color-choice-1-label"
                    />
                    <p id="color-choice-1-label">Red</p>
                    <div
                      class="absolute -inset-px rounded-md pointer-events-none"
                      aria-hidden="true"
                    ></div>
                  </label>

                  <!-- Active: "ring-2 ring-indigo-500" -->
                  <label
                    class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-xs sm:text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer"
                  >
                    <input
                      type="radio"
                      name="color-choice"
                      value="Black"
                      class="sr-only"
                      aria-labelledby="color-choice-2-label"
                    />
                    <p id="color-choice-2-label">Black</p>
                    <div
                      class="absolute -inset-px rounded-md pointer-events-none"
                      aria-hidden="true"
                    ></div>
                  </label>

                  <!-- Active: "ring-2 ring-indigo-500" -->
                  <label
                    class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-xs sm:text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer"
                  >
                    <input
                      type="radio"
                      name="color-choice"
                      value="Purple"
                      class="sr-only"
                      aria-labelledby="color-choice-3-label"
                    />
                    <p id="color-choice-3-label">Purple</p>
                    <div
                      class="absolute -inset-px rounded-md pointer-events-none"
                      aria-hidden="true"
                    ></div>
                  </label>

                  <!-- Active: "ring-2 ring-indigo-500" -->
                  <label
                    class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-xs sm:text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer"
                  >
                    <input
                      type="radio"
                      name="color-choice"
                      value="Beige"
                      class="sr-only"
                      aria-labelledby="color-choice-4-label"
                    />
                    <p id="color-choice-4-label">Beige</p>
                    <div
                      class="absolute -inset-px rounded-md pointer-events-none"
                      aria-hidden="true"
                    ></div>
                  </label>

                  <!-- Active: "ring-2 ring-indigo-500" -->
                  <label
                    class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-xs sm:text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer"
                  >
                    <input
                      type="radio"
                      name="color-choice"
                      value="Orange"
                      class="sr-only"
                      aria-labelledby="color-choice-5-label"
                    />
                    <p id="color-choice-5-label">Orange</p>
                    <div
                      class="absolute -inset-px rounded-md pointer-events-none"
                      aria-hidden="true"
                    ></div>
                  </label>

                  <!-- Active: "ring-2 ring-indigo-500" -->
                  <label
                    class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-xs sm:text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer"
                  >
                    <input
                      type="radio"
                      name="color-choice"
                      value="Brown"
                      class="sr-only"
                      aria-labelledby="color-choice-6-label"
                    />
                    <p id="color-choice-6-label">Brown</p>
                    <div
                      class="absolute -inset-px rounded-md pointer-events-none"
                      aria-hidden="true"
                    ></div>
                  </label>

                  <!-- Active: "ring-2 ring-indigo-500" -->
                  <label
                    class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-xs sm:text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer"
                  >
                    <input
                      type="radio"
                      name="color-choice"
                      value="Green"
                      disabled
                      class="sr-only"
                      aria-labelledby="color-choice-7-label"
                    />
                    <p id="color-choice-7-label">Green</p>
                    <div
                      class="absolute -inset-px rounded-md pointer-events-none"
                      aria-hidden="true"
                    ></div>
                  </label>
                </div>
              </div>
            </div>
            <div class="py-6 border-b border-gray-300">
              <button
                type="button"
                class="flex items-center justify-between w-full text-gray-400 focus:outline-none"
              >
                <span class="font-medium text-gray-800">Size</span>
                <svg
                  class="h-6 w-6 transform rotate-45"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
              <div class="pt-6">
                <div class="grid grid-cols-4 gap-4">
                  <!-- Active: "ring-2 ring-indigo-500" -->
                  <label
                    class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-xs sm:text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer ring-2 ring-indigo-500"
                  >
                    <input
                      type="radio"
                      name="size-choice"
                      value="XXS"
                      class="sr-only"
                      aria-labelledby="size-choice-0-label"
                    />
                    <p id="size-choice-0-label">XXS</p>
                    <div
                      class="absolute -inset-px rounded-md pointer-events-none"
                      aria-hidden="true"
                    ></div>
                  </label>

                  <!-- Active: "ring-2 ring-indigo-500" -->
                  <label
                    class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-xs sm:text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer"
                  >
                    <input
                      type="radio"
                      name="size-choice"
                      value="XS"
                      class="sr-only"
                      aria-labelledby="size-choice-1-label"
                    />
                    <p id="size-choice-1-label">XS</p>
                    <div
                      class="absolute -inset-px rounded-md pointer-events-none"
                      aria-hidden="true"
                    ></div>
                  </label>

                  <!-- Active: "ring-2 ring-indigo-500" -->
                  <label
                    class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-xs sm:text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer"
                  >
                    <input
                      type="radio"
                      name="size-choice"
                      value="S"
                      class="sr-only"
                      aria-labelledby="size-choice-2-label"
                    />
                    <p id="size-choice-2-label">S</p>
                    <div
                      class="absolute -inset-px rounded-md pointer-events-none"
                      aria-hidden="true"
                    ></div>
                  </label>

                  <!-- Active: "ring-2 ring-indigo-500" -->
                  <label
                    class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-xs sm:text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer"
                  >
                    <input
                      type="radio"
                      name="size-choice"
                      value="M"
                      class="sr-only"
                      aria-labelledby="size-choice-3-label"
                    />
                    <p id="size-choice-3-label">M</p>
                    <div
                      class="absolute -inset-px rounded-md pointer-events-none"
                      aria-hidden="true"
                    ></div>
                  </label>

                  <!-- Active: "ring-2 ring-indigo-500" -->
                  <label
                    class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-xs sm:text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer"
                  >
                    <input
                      type="radio"
                      name="size-choice"
                      value="L"
                      class="sr-only"
                      aria-labelledby="size-choice-4-label"
                    />
                    <p id="size-choice-4-label">L</p>
                    <div
                      class="absolute -inset-px rounded-md pointer-events-none"
                      aria-hidden="true"
                    ></div>
                  </label>

                  <!-- Active: "ring-2 ring-indigo-500" -->
                  <label
                    class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-xs sm:text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer"
                  >
                    <input
                      type="radio"
                      name="size-choice"
                      value="XL"
                      class="sr-only"
                      aria-labelledby="size-choice-5-label"
                    />
                    <p id="size-choice-5-label">XL</p>
                    <div
                      class="absolute -inset-px rounded-md pointer-events-none"
                      aria-hidden="true"
                    ></div>
                  </label>

                  <!-- Active: "ring-2 ring-indigo-500" -->
                  <label
                    class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-xs sm:text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer"
                  >
                    <input
                      type="radio"
                      name="size-choice"
                      value="XXL"
                      class="sr-only"
                      aria-labelledby="size-choice-6-label"
                    />
                    <p id="size-choice-6-label">XXL</p>
                    <div
                      class="absolute -inset-px rounded-md pointer-events-none"
                      aria-hidden="true"
                    ></div>
                  </label>

                  <!-- Active: "ring-2 ring-indigo-500" -->
                  <label
                    class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-xs sm:text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-gray-50 text-gray-200 cursor-not-allowed"
                  >
                    <input
                      type="radio"
                      name="size-choice"
                      value="XXXL"
                      disabled
                      class="sr-only"
                      aria-labelledby="size-choice-7-label"
                    />
                    <p id="size-choice-7-label">XXXL</p>

                    <div
                      aria-hidden="true"
                      class="absolute -inset-px rounded-md border-2 border-gray-200 pointer-events-none"
                    >
                      <svg
                        class="absolute inset-0 w-full h-full text-gray-200 stroke-2"
                        viewBox="0 0 100 100"
                        preserveAspectRatio="none"
                        stroke="currentColor"
                      >
                        <line
                          x1="0"
                          y1="100"
                          x2="100"
                          y2="0"
                          vector-effect="non-scaling-stroke"
                        />
                      </svg>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="my-10">
      <div class="max-w-screen-xl mx-auto p-4 sm:p-10 bg-white">
        <div
          class="relative z-10 flex items-center justify-between pb-6 border-b border-gray-200"
        >
          <h1
            class="text-2xl sm:text-4xl font-extrabold tracking-tight text-gray-900"
          >
            Filter
          </h1>

          <div class="flex items-center">
            <button class="relative text-sm focus:outline-none dropdown">
              <div
                class="flex items-center justify-between w-40 h-10 px-3 rounded hover:bg-gray-100"
              >
                <span class="font-medium"> Popular </span>
                <svg
                  class="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <div
                class="absolute z-10 flex-col items-start hidden w-full bg-white shadow-lg rounded dropdown-menu"
              >
                <a class="w-full px-4 py-2 text-left hover:bg-gray-200" href="#"
                  >Popular</a
                >
                <a class="w-full px-4 py-2 text-left hover:bg-gray-200" href="#"
                  >Featured</a
                >
                <a class="w-full px-4 py-2 text-left hover:bg-gray-200" href="#"
                  >Newest</a
                >
                <a class="w-full px-4 py-2 text-left hover:bg-gray-200" href="#"
                  >Lowest Price</a
                >
                <a class="w-full px-4 py-2 text-left hover:bg-gray-200" href="#"
                  >Highest Price</a
                >
              </div>
            </button>

            <button
              type="button"
              class="p-2 -m-2 ml-5 sm:ml-7 text-gray-400 hover:text-gray-500"
            >
              <span class="sr-only">View grid</span>
              <svg
                class="w-5 h-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                />
              </svg>
            </button>
            <button
              type="button"
              class="p-2 -m-2 ml-4 sm:ml-6 text-gray-400 hover:text-gray-500"
            >
              <span class="sr-only">Filters</span>
              <svg
                class="w-5 h-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </div>
        </div>
        <div class="mt-6">
          <div class="w-full md:w-96">
            <div class="py-6 border-b border-gray-300">
              <button
                type="button"
                class="flex items-center justify-between w-full text-gray-400 focus:outline-none"
              >
                <span class="font-medium text-gray-800">Product Type</span>
                <svg
                  class="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
              <div class="pt-6">
                <div class="space-y-6">
                  <div class="flex items-center">
                    <input
                      id="product-type-5"
                      name="product-type[]"
                      value="white"
                      checked
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="product-type-5"
                      class="flex items-center justify-between ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      <span>Clock</span>
                      <span
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gray-200 text-gray-800"
                      >
                        120
                      </span>
                    </label>
                  </div>

                  <div class="flex items-center">
                    <input
                      id="product-type-6"
                      name="product-type[]"
                      value="beige"
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="product-type-6"
                      class="flex items-center justify-between ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      <span>Television</span>
                      <span
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gray-200 text-gray-800"
                      >
                        50
                      </span>
                    </label>
                  </div>

                  <div class="flex items-center">
                    <input
                      id="product-type-7"
                      name="product-type[]"
                      value="blue"
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="product-type-7"
                      class="flex items-center justify-between ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      <span>Desk Mate</span>
                      <span
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gray-200 text-gray-800"
                      >
                        137
                      </span>
                    </label>
                  </div>

                  <div class="flex items-center">
                    <input
                      id="product-type-8"
                      name="product-type[]"
                      value="brown"
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="product-type-8"
                      class="flex items-center justify-between ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      <span>Mouse</span>
                      <span
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gray-200 text-gray-800"
                      >
                        99
                      </span>
                    </label>
                  </div>

                  <div class="flex items-center">
                    <input
                      id="product-type-9"
                      name="product-type[]"
                      value="green"
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="product-type-9"
                      class="flex items-center justify-between ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      <span>Laptop</span>
                      <span
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gray-200 text-gray-800"
                      >
                        359
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="py-6 border-b border-gray-300">
              <button
                type="button"
                class="flex items-center justify-between w-full text-gray-400 focus:outline-none"
              >
                <span class="font-medium text-gray-800">Color</span>
                <svg
                  class="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
              <div class="pt-6">
                <div class="space-y-6">
                  <div class="flex items-center">
                    <input
                      id="color-0"
                      name="color[]"
                      value="white"
                      checked
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="color-0"
                      class="ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      White
                    </label>
                  </div>

                  <div class="flex items-center">
                    <input
                      id="color-1"
                      name="color[]"
                      value="beige"
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="color-1"
                      class="ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      Beige
                    </label>
                  </div>

                  <div class="flex items-center">
                    <input
                      id="color-2"
                      name="color[]"
                      value="blue"
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="color-2"
                      class="ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      Blue
                    </label>
                  </div>

                  <div class="flex items-center">
                    <input
                      id="color-3"
                      name="color[]"
                      value="brown"
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="color-3"
                      class="ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      Brown
                    </label>
                  </div>

                  <div class="flex items-center">
                    <input
                      id="color-4"
                      name="color[]"
                      value="green"
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="color-4"
                      class="ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      Green
                    </label>
                  </div>

                  <div class="flex items-center">
                    <input
                      id="color-5"
                      name="color[]"
                      value="purple"
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="color-5"
                      class="ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      Purple
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="py-6 border-b border-gray-300">
              <button
                type="button"
                class="flex items-center justify-between w-full text-gray-400 focus:outline-none"
              >
                <span class="font-medium text-gray-800">Size</span>
                <svg
                  class="h-6 w-6 transform rotate-45"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
              <div class="pt-6">
                <div class="space-y-6">
                  <div class="flex items-center">
                    <input
                      id="size-0"
                      name="color[]"
                      value="white"
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="size-0"
                      class="ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      XS
                    </label>
                  </div>

                  <div class="flex items-center">
                    <input
                      id="size-1"
                      name="color[]"
                      value="beige"
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="size-1"
                      class="ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      SM
                    </label>
                  </div>

                  <div class="flex items-center">
                    <input
                      id="size-2"
                      name="color[]"
                      value="blue"
                      type="checkbox"
                      checked
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="size-2"
                      class="ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      M
                    </label>
                  </div>

                  <div class="flex items-center">
                    <input
                      id="size-3"
                      name="color[]"
                      value="brown"
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="size-3"
                      class="ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      L
                    </label>
                  </div>

                  <div class="flex items-center">
                    <input
                      id="size-4"
                      name="color[]"
                      value="green"
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="size-4"
                      class="ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      XL
                    </label>
                  </div>

                  <div class="flex items-center">
                    <input
                      id="size-5"
                      name="color[]"
                      value="purple"
                      type="checkbox"
                      class="h-6 w-6 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      for="size-5"
                      class="ml-3 min-w-0 flex-1 text-gray-500"
                    >
                      XXL
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="my-10">
      <div
        class="w-full sm:w-3/4 md:w-2/3 xl:w-1/3 mx-auto bg-blue-900 px-4 py-10 sm:p-10"
      >
        <div class="flex flex-col text-white">
          <span class="text-sm opacity-70">Amount due</span>
          <span class="text-3xl font-bold">$199,99</span>
        </div>
        <div
          class="flex py-6 border-b border-gray-50 border-opacity-20 text-white"
        >
          <div class="mr-4">
            <img
              class="w-20 h-20 rounded-md"
              :src="`${publicPath}unsplash.jpeg`"
              alt=""
            />
          </div>
          <div class="flex flex-col font-medium space-y-1.5">
            <span>Polo Shirt</span>
            <span class="text-xs opacity-70">Turquise and Red</span>
            <span class="text-xs opacity-70">L and XL</span>
          </div>
          <span class="ml-auto font-bold"> $70,39 </span>
        </div>
        <div
          class="flex py-6 border-b border-gray-50 border-opacity-20 text-white"
        >
          <div class="mr-4">
            <img
              class="w-20 h-20 rounded-md"
              :src="`${publicPath}unsplash.jpeg`"
              alt=""
            />
          </div>
          <div class="flex flex-col font-medium space-y-1.5">
            <span>Short</span>
            <span class="text-xs opacity-70">Blue</span>
            <span class="text-xs opacity-70">XL</span>
          </div>
          <span class="ml-auto font-bold"> $35,99 </span>
        </div>
        <div
          class="flex py-6 border-b border-gray-50 border-opacity-20 text-white"
        >
          <div class="mr-4">
            <img
              class="w-20 h-20 rounded-md"
              :src="`${publicPath}unsplash.jpeg`"
              alt=""
            />
          </div>
          <div class="flex flex-col font-medium space-y-1.5">
            <span>Coat</span>
            <span class="text-xs opacity-70">Red</span>
            <span class="text-xs opacity-70">XXL</span>
          </div>
          <span class="ml-auto font-bold"> $270,39 </span>
        </div>
        <div
          class="text-white opacity-70 space-y-3 border-b border-gray-50 border-opacity-20 py-6"
        >
          <div class="flex items-center justify-between">
            <span>Subtotal</span>
            <span class="font-bold">$376,77</span>
          </div>
          <div class="flex items-center justify-between">
            <span>Shipping</span>
            <span class="font-bold">Free Shipping</span>
          </div>
          <div class="flex items-center justify-between">
            <span>Taxes</span>
            <span class="font-bold">$21,99</span>
          </div>
        </div>
        <div class="text-white space-y-3 pt-6">
          <div class="flex items-center justify-between">
            <span>Total</span>
            <span class="font-bold">$398,76</span>
          </div>
        </div>
      </div>
    </div>
    <div class="my-10">
      <div class="w-full md:w-96 bg-white mx-auto rounded-xl p-5">
        <div class="flex flex-col space-y-4">
          <span class="text-md text-gray-800 font-semibold"
            >Fujifilm X-T4 APS-C</span
          >
          <span>$1599</span>
        </div>
        <div class="mt-6">
          <span>Color: <strong>White</strong></span>
          <div class="mt-4">
            <span
              class="w-5 h-5 inline-block bg-white border-2 border-indigo-500 rounded-full transition hover:border-indigo-500"
            ></span>
            <span
              class="w-5 h-5 inline-block bg-gray-300 border-2 border-transparent rounded-full transition hover:border-indigo-500"
            ></span>
            <span
              class="w-5 h-5 inline-block bg-black border-2 border-transparent rounded-full transition hover:border-indigo-500"
            ></span>
          </div>
        </div>
        <div class="mt-6">
          <div class="flex items-center justify-between">
            <h4 class="text-sm text-gray-900 font-medium">Size</h4>
            <a
              href="#"
              class="text-sm font-medium text-indigo-600 hover:text-indigo-500"
              >Size guide</a
            >
          </div>

          <fieldset class="mt-4">
            <legend class="sr-only">Choose a size</legend>
            <div class="grid grid-cols-4 gap-4">
              <!-- Active: "ring-2 ring-indigo-500" -->
              <label
                class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer ring-2 ring-indigo-500"
              >
                <input
                  type="radio"
                  name="size-choice"
                  value="XXS"
                  class="sr-only"
                  aria-labelledby="size-choice-0-label"
                />
                <p id="size-choice-0-label">XXS</p>
                <div
                  class="absolute -inset-px rounded-md pointer-events-none"
                  aria-hidden="true"
                ></div>
              </label>

              <!-- Active: "ring-2 ring-indigo-500" -->
              <label
                class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer"
              >
                <input
                  type="radio"
                  name="size-choice"
                  value="XS"
                  class="sr-only"
                  aria-labelledby="size-choice-1-label"
                />
                <p id="size-choice-1-label">XS</p>
                <div
                  class="absolute -inset-px rounded-md pointer-events-none"
                  aria-hidden="true"
                ></div>
              </label>

              <!-- Active: "ring-2 ring-indigo-500" -->
              <label
                class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer"
              >
                <input
                  type="radio"
                  name="size-choice"
                  value="S"
                  class="sr-only"
                  aria-labelledby="size-choice-2-label"
                />
                <p id="size-choice-2-label">S</p>
                <div
                  class="absolute -inset-px rounded-md pointer-events-none"
                  aria-hidden="true"
                ></div>
              </label>

              <!-- Active: "ring-2 ring-indigo-500" -->
              <label
                class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer"
              >
                <input
                  type="radio"
                  name="size-choice"
                  value="M"
                  class="sr-only"
                  aria-labelledby="size-choice-3-label"
                />
                <p id="size-choice-3-label">M</p>
                <div
                  class="absolute -inset-px rounded-md pointer-events-none"
                  aria-hidden="true"
                ></div>
              </label>

              <!-- Active: "ring-2 ring-indigo-500" -->
              <label
                class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer"
              >
                <input
                  type="radio"
                  name="size-choice"
                  value="L"
                  class="sr-only"
                  aria-labelledby="size-choice-4-label"
                />
                <p id="size-choice-4-label">L</p>
                <div
                  class="absolute -inset-px rounded-md pointer-events-none"
                  aria-hidden="true"
                ></div>
              </label>

              <!-- Active: "ring-2 ring-indigo-500" -->
              <label
                class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer"
              >
                <input
                  type="radio"
                  name="size-choice"
                  value="XL"
                  class="sr-only"
                  aria-labelledby="size-choice-5-label"
                />
                <p id="size-choice-5-label">XL</p>
                <div
                  class="absolute -inset-px rounded-md pointer-events-none"
                  aria-hidden="true"
                ></div>
              </label>

              <!-- Active: "ring-2 ring-indigo-500" -->
              <label
                class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-white shadow-sm text-gray-900 cursor-pointer"
              >
                <input
                  type="radio"
                  name="size-choice"
                  value="XXL"
                  class="sr-only"
                  aria-labelledby="size-choice-6-label"
                />
                <p id="size-choice-6-label">XXL</p>
                <div
                  class="absolute -inset-px rounded-md pointer-events-none"
                  aria-hidden="true"
                ></div>
              </label>

              <!-- Active: "ring-2 ring-indigo-500" -->
              <label
                class="group relative border rounded-md py-3 px-4 flex items-center justify-center text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 bg-gray-50 text-gray-200 cursor-not-allowed"
              >
                <input
                  type="radio"
                  name="size-choice"
                  value="XXXL"
                  disabled
                  class="sr-only"
                  aria-labelledby="size-choice-7-label"
                />
                <p id="size-choice-7-label">XXXL</p>

                <div
                  aria-hidden="true"
                  class="absolute -inset-px rounded-md border-2 border-gray-200 pointer-events-none"
                >
                  <svg
                    class="absolute inset-0 w-full h-full text-gray-200 stroke-2"
                    viewBox="0 0 100 100"
                    preserveAspectRatio="none"
                    stroke="currentColor"
                  >
                    <line
                      x1="0"
                      y1="100"
                      x2="100"
                      y2="0"
                      vector-effect="non-scaling-stroke"
                    />
                  </svg>
                </div>
              </label>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="my-10">
      <div class="w-full sm:w-96 mx-auto bg-white p-1 rounded-xl space-y-2">
        <img
          class="w-full md:w-96 rounded-xl"
          src="assets/images/ecommerce/photograph-machine.jpg"
          alt=""
        />
        <div class="flex gap-1 items-center justify-between">
          <span
            class="w-20 h-20 rounded-xl border-2 border-white hover:border-gray-800 overflow-hidden cursor-pointer transition"
          >
            <img :src="`${publicPath}unsplash.jpeg`" alt="" />
          </span>
          <span
            class="w-20 h-20 rounded-xl border-2 border-white hover:border-gray-800 overflow-hidden cursor-pointer transition"
          >
            <img :src="`${publicPath}unsplash.jpeg`" alt="" />
          </span>
          <span
            class="w-20 h-20 rounded-xl border-2 border-white hover:border-gray-800 overflow-hidden cursor-pointer transition"
          >
            <img :src="`${publicPath}unsplash.jpeg`" alt="" />
          </span>
          <span
            class="w-20 h-20 rounded-xl border-2 border-white hover:border-gray-800 overflow-hidden cursor-pointer transition"
          >
            <img :src="`${publicPath}unsplash.jpeg`" alt="" />
          </span>
        </div>
      </div>
    </div>
    <div class="my-10">
      <div class="w-full md:w-96 mx-auto">
        <fieldset>
          <legend class="sr-only">Shipment</legend>
          <div class="relative bg-white rounded-xl shadow-lg -space-y-px">
            <label
              class="relative p-4 flex justify-between cursor-pointer md:pl-4 md:pr-6"
            >
              <div class="flex space-x-4">
                <input
                  type="radio"
                  name="shipment_plan"
                  value="dhl-standard"
                  class="h-4 w-4 mt-1 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                  aria-labelledby="shipping-plan-0-label"
                  aria-describedby="shipping-plan-0-description-0 shipping-plan-0-description-1"
                />
                <div class="flex flex-col">
                  <span
                    id="shipping-plan-0-label"
                    class="text-sm font-semibold text-gray-900"
                    >DHL - Standard Delivery</span
                  >
                  <span class="text-sm text-gray-400"
                    >Takes 2 to 3 days to arrive</span
                  >
                </div>
              </div>
              <span class="text-xs font-semibold text-gray-900">Free</span>
            </label>

            <label
              class="relative p-4 flex justify-between cursor-pointer md:pl-4 md:pr-6"
            >
              <div class="flex space-x-4">
                <input
                  type="radio"
                  name="shipment_plan"
                  value="dhl-fast"
                  class="h-4 w-4 mt-1 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                  checked
                  aria-labelledby="shipping-plan-1-label"
                  aria-describedby="shipping-plan-1-description-1 shipping-plan-1-description-2"
                />
                <div class="flex flex-col">
                  <span
                    id="shipping-plan-1-label"
                    class="text-sm font-semibold text-indigo-500"
                    >DHL - Fast Tracked</span
                  >
                  <span class="text-sm text-gray-400"
                    >Takes 2 to 3 days to arrive</span
                  >
                </div>
              </div>
              <span class="text-xs font-semibold text-indigo-500">$5,99</span>
            </label>

            <label
              class="relative p-4 flex justify-between cursor-pointer md:pl-4 md:pr-6"
            >
              <div class="flex space-x-4">
                <input
                  type="radio"
                  name="shipment_plan"
                  value="ups-next-day"
                  class="h-4 w-4 mt-1 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                  aria-labelledby="shipping-plan-1-label"
                  aria-describedby="shipping-plan-1-description-1 shipping-plan-1-description-2"
                />
                <div class="flex flex-col">
                  <span
                    id="shipping-plan-1-label"
                    class="text-sm font-semibold text-gray-900"
                    >UPS - Next Day Delivery</span
                  >
                  <span class="text-sm text-gray-400"
                    >Takes 2 to 3 days to arrive</span
                  >
                </div>
              </div>
              <span class="text-xs font-semibold text-gray-900">$15,99</span>
            </label>
          </div>
        </fieldset>
      </div>
    </div>
    <div class="my-10">
      <div class="w-full md:w-96 mx-auto bg-white shadow-lg rounded-xl p-6">
        <h6 class="text-gray-700 text-lg font-bold">Order Summary</h6>
        <ul>
          <li
            class="flex items-center justify-between py-6 text-md border-b border-gray-100"
          >
            <span class="text-gray-500">Subtotal</span>
            <span class="text-gray-700 font-semibold">$3,579</span>
          </li>
          <li
            class="flex items-center justify-between py-6 text-md border-b border-gray-100"
          >
            <span class="text-gray-500">Shipping</span>
            <span class="text-green-500 font-semibold">Free</span>
            <span class="hidden text-gray-700 font-semibold">$35</span>
          </li>
          <li
            class="flex items-center justify-between py-6 text-md border-b border-gray-100"
          >
            <span class="text-gray-500">VAT (included)</span>
            <span class="text-gray-700 font-semibold">%18</span>
          </li>
          <li
            class="flex items-center justify-between py-6 text-md border-b border-gray-100"
          >
            <span class="text-gray-500">Total</span>
            <span class="text-indigo-500 font-semibold">$3,579</span>
          </li>
        </ul>
        <div class="mt-6">
          <div>
            <label
              for="add-promo-code"
              class="block text-sm font-semibold text-gray-600"
            >
              Add promo code
            </label>
            <div class="mt-3">
              <input
                type="text"
                name="add-promo-code"
                id="add-promo-code"
                autocomplete="given-name"
                class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
              />
            </div>
          </div>
          <button
            type="button"
            class="inline-flex items-center justify-center w-full px-4 py-2 mt-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-gray-900 bg-gray-100 hover:bg-gray-300 transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
          >
            Apply code
          </button>
          <button
            type="button"
            class="inline-flex items-center justify-center w-full px-4 py-2 mt-6 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Checkout
          </button>
        </div>
      </div>
    </div>
    <div class="bg-white max-w-screen-2xl mx-auto my-10">
      <div class="flex flex-wrap py-10">
        <div class="w-full lg:w-1/2 px-4 2xl:px-8">
          <div class="flex flex-col-reverse lg:flex-row gap-4">
            <div class="lg:w-32 flex flex-row lg:flex-col">
              <button
                type="button"
                class="inline-flex items-center justify-center my-2 py-2 hover:shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 transform -rotate-90 lg:rotate-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 15l7-7 7 7"
                  />
                </svg>
              </button>
              <div
                class="flex flex-row lg:flex-col lg:flex-wrap items-center justify-center space-x-2 lg:space-x-0 lg:space-y-2"
              >
                <span
                  class="relative inline-block w-full rounded-sm cursor-pointer"
                >
                  <img :src="`${publicPath}unsplash.jpeg`" alt="" />
                </span>
                <span
                  class="relative inline-block w-full rounded-sm cursor-pointer opacity-30 transition-opacity hover:opacity-100"
                >
                  <img :src="`${publicPath}unsplash.jpeg`" alt="" />
                </span>
                <span
                  class="relative inline-block w-full rounded-sm cursor-pointer opacity-30 transition-opacity hover:opacity-100"
                >
                  <img :src="`${publicPath}unsplash.jpeg`" alt="" />
                </span>
                <span
                  class="relative inline-block w-full rounded-sm cursor-pointer opacity-30 transition-opacity hover:opacity-100"
                >
                  <img :src="`${publicPath}unsplash.jpeg`" alt="" />
                </span>
              </div>
              <button
                type="button"
                class="inline-flex items-center justify-center my-2 py-2 hover:shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 transform -rotate-90 lg:rotate-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
            </div>
            <div class="flex items-center justify-center">
              <img :src="`${publicPath}unsplash.jpeg`" alt="" />
            </div>
          </div>
        </div>
        <div class="w-full lg:w-1/2 px-4 2xl:px-8">
          <div class="space-y-8">
            <div class="space-y-3">
              <span>Color: <strong>Blue</strong></span>
              <div class="flex flex-wrap items-center gap-4">
                <span
                  class="relative inline-flex items-center justify-center w-14 h-14 sm:w-20 sm:h-20 border-2 border-gray-800 rounded-md cursor-pointer"
                >
                  <img
                    class="rounded-md"
                    :src="`${publicPath}unsplash.jpeg`"
                    alt=""
                  />
                </span>
                <span
                  class="relative inline-flex items-center justify-center w-14 h-14 sm:w-20 sm:h-20 border-2 border-white rounded-md cursor-pointer hover:border-gray-800"
                >
                  <img
                    class="rounded-md"
                    :src="`${publicPath}unsplash.jpeg`"
                    alt=""
                  />
                </span>
                <span
                  class="relative inline-flex items-center justify-center w-14 h-14 sm:w-20 sm:h-20 border-2 border-white rounded-md cursor-pointer hover:border-gray-800"
                >
                  <img
                    class="rounded-md"
                    :src="`${publicPath}unsplash.jpeg`"
                    alt=""
                  />
                </span>
                <span
                  class="relative inline-flex items-center justify-center w-14 h-14 sm:w-20 sm:h-20 border-2 border-white rounded-md cursor-pointer hover:border-gray-800"
                >
                  <img
                    class="rounded-md"
                    :src="`${publicPath}unsplash.jpeg`"
                    alt=""
                  />
                </span>
              </div>
            </div>
            <div class="space-y-3">
              <div class="flex items-center justify-between">
                <span>Size: <strong>S</strong></span>
                <button
                  type="button"
                  class="inline-flex items-center text-indigo-500 rounded-md space-x-3 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-6 h-6"
                    viewBox="0 0 24 24"
                  >
                    <g fill="currentColor">
                      <path
                        d="M24 17.573a1.917 1.917 0 0 0-1.065-1.724l-8.985-4.492a.25.25 0 0 1-.026-.432A3.5 3.5 0 1 0 8.5 8a1 1 0 0 0 2 0 1.5 1.5 0 1 1 1.986 1.42A2.2 2.2 0 0 0 11 11.5a1 1 0 0 0 .553.895l9.347 4.631a.25.25 0 0 1-.111.474H3.261a.25.25 0 0 1-.114-.473l5.808-2.963a1 1 0 1 0-.91-1.781l-6.992 3.568A1.93 1.93 0 0 0 1.93 19.5h20.143A1.93 1.93 0 0 0 24 17.573z"
                      ></path>
                    </g>
                  </svg>
                  <span>Size guide</span>
                </button>
              </div>
              <div class="grid grid-cols-4 gap-4">
                <!-- Active ring-2 ring-indigo-500 -->
                <button
                  type="button"
                  class="inline-block py-3 px-4 bg-white text-gray-900 text-sm font-semibold rounded-md border shadow-sm hover:bg-gray-50 ring-2 ring-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
                >
                  XXS
                </button>
                <!-- Active ring-2 ring-indigo-500 -->
                <button
                  type="button"
                  class="inline-block py-3 px-4 bg-white text-gray-900 text-sm font-semibold rounded-md border shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
                >
                  XXS
                </button>
                <!-- Active ring-2 ring-indigo-500 -->
                <button
                  type="button"
                  class="inline-block py-3 px-4 bg-white text-gray-900 text-sm font-semibold rounded-md border shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
                >
                  XS
                </button>
                <!-- Active ring-2 ring-indigo-500 -->
                <button
                  type="button"
                  class="inline-block py-3 px-4 bg-white text-gray-900 text-sm font-semibold rounded-md border shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
                >
                  S
                </button>
                <!-- Active ring-2 ring-indigo-500 -->
                <button
                  type="button"
                  class="inline-block py-3 px-4 bg-white text-gray-900 text-sm font-semibold rounded-md border shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
                >
                  M
                </button>
                <!-- Active ring-2 ring-indigo-500 -->
                <button
                  type="button"
                  class="inline-block py-3 px-4 bg-white text-gray-900 text-sm font-semibold rounded-md border shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
                >
                  L
                </button>
                <!-- Active ring-2 ring-indigo-500 -->
                <button
                  type="button"
                  class="inline-block py-3 px-4 bg-white text-gray-900 text-sm font-semibold rounded-md border shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
                >
                  XL
                </button>
                <!-- Active ring-2 ring-indigo-500 -->
                <button
                  type="button"
                  class="inline-block py-3 px-4 bg-white text-gray-900 text-sm font-semibold rounded-md border shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
                >
                  XXL
                </button>
              </div>
            </div>
            <div
              class="flex sm:items-center flex-col sm:flex-row py-8 border-t border-b border-gray-300 space-y-4 sm:space-y-0 sm:space-x-8"
            >
              <span class="text-2xl font-semibold">$1200</span>
              <button
                type="button"
                class="text-md bg-gray-800 text-white py-3 px-6 rounded-md uppercase focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
              >
                Add To Card
              </button>
              <div class="space-x-8">
                <button
                  type="button"
                  class="inline-flex text-gray-400 hover:text-red-600"
                >
                  <svg
                    fill="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    class="w-5 h-5"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"
                    ></path>
                  </svg>
                </button>
                <button
                  type="button"
                  class="inline-flex text-gray-400 hover:text-green-600"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div
              class="flex flex-col xl:flex-row space-y-3 xl:space-y-0 xl:space-x-2 2xl:space-x-5"
            >
              <span class="inline-flex items-center text-md text-gray-400">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 mr-3"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
                  />
                </svg>
                Shipping & Delivery
              </span>
              <span class="inline-flex items-center text-md text-gray-400">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 mr-3"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  />
                </svg>
                Recyclable fabric
              </span>
              <span class="inline-flex items-center text-md text-gray-400"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 mr-3"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                Ask a Question
              </span>
            </div>
            <div class="space-y-8">
              <div class="relative">
                <div
                  class="absolute inset-0 flex items-center"
                  aria-hidden="true"
                >
                  <div class="w-full border-t border-gray-300"></div>
                </div>
                <div class="relative flex justify-start">
                  <span class="pr-3 bg-white text-sm font-medium text-gray-900">
                    GUARANTED SAFE CHECKOUT
                  </span>
                </div>
              </div>
              <div class="flex items-center space-x-8">
                <svg
                  class="h-8 w-auto sm:flex-shrink-0 sm:h-6"
                  viewBox="0 0 36 24"
                  aria-hidden="true"
                >
                  <rect width="36" height="24" fill="#224DBA" rx="4"></rect>
                  <path
                    fill="#fff"
                    d="M10.925 15.673H8.874l-1.538-6c-.073-.276-.228-.52-.456-.635A6.575 6.575 0 005 8.403v-.231h3.304c.456 0 .798.347.855.75l.798 4.328 2.05-5.078h1.994l-3.076 7.5zm4.216 0h-1.937L14.8 8.172h1.937l-1.595 7.5zm4.101-5.422c.057-.404.399-.635.798-.635a3.54 3.54 0 011.88.346l.342-1.615A4.808 4.808 0 0020.496 8c-1.88 0-3.248 1.039-3.248 2.481 0 1.097.969 1.673 1.653 2.02.74.346 1.025.577.968.923 0 .519-.57.75-1.139.75a4.795 4.795 0 01-1.994-.462l-.342 1.616a5.48 5.48 0 002.108.404c2.108.057 3.418-.981 3.418-2.539 0-1.962-2.678-2.077-2.678-2.942zm9.457 5.422L27.16 8.172h-1.652a.858.858 0 00-.798.577l-2.848 6.924h1.994l.398-1.096h2.45l.228 1.096h1.766zm-2.905-5.482l.57 2.827h-1.596l1.026-2.827z"
                  ></path>
                </svg>
                <svg
                  width="76"
                  height="19"
                  viewBox="0 0 76 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M28.4156 4.09029H24.2102C24.071 4.0902 23.9363 4.13912 23.8304 4.22824C23.7246 4.31735 23.6545 4.44081 23.6328 4.57635L21.9319 15.2048C21.9241 15.2542 21.9272 15.3046 21.9411 15.3526C21.9549 15.4006 21.9792 15.4451 22.0121 15.483C22.0451 15.5209 22.086 15.5513 22.132 15.5721C22.178 15.5929 22.2281 15.6037 22.2788 15.6036H24.2865C24.4258 15.6037 24.5605 15.5547 24.6664 15.4654C24.7723 15.3762 24.8423 15.2526 24.8639 15.117L25.3226 12.2503C25.3441 12.1147 25.4141 11.9912 25.5198 11.902C25.6256 11.8128 25.7602 11.7637 25.8994 11.7636H27.2307C30.0009 11.7636 31.5997 10.4424 32.0172 7.82423C32.2054 6.67877 32.0252 5.77877 31.481 5.14847C30.8833 4.45635 29.8232 4.09029 28.4156 4.09029V4.09029ZM28.9008 7.9721C28.6708 9.45938 27.5179 9.45938 26.403 9.45938H25.7684L26.2136 6.6818C26.2267 6.60054 26.2687 6.52653 26.3321 6.47309C26.3956 6.41965 26.4763 6.39029 26.5598 6.39029H26.8507C27.6101 6.39029 28.3265 6.39029 28.6967 6.81695C28.9174 7.0715 28.9851 7.44968 28.9008 7.9721V7.9721ZM40.9864 7.92423H38.9726C38.8891 7.92423 38.8084 7.95359 38.7449 8.00703C38.6814 8.06047 38.6394 8.13448 38.6264 8.21574L38.5372 8.77089L38.3964 8.56968C37.9604 7.94604 36.9882 7.73756 36.0179 7.73756C33.7925 7.73756 31.8918 9.39877 31.5216 11.7291C31.3291 12.8915 31.6028 14.003 32.2718 14.7782C32.8855 15.4909 33.7636 15.7879 34.8083 15.7879C36.6015 15.7879 37.5958 14.6515 37.5958 14.6515L37.506 15.203C37.498 15.2523 37.5009 15.3028 37.5146 15.3508C37.5283 15.3989 37.5524 15.4435 37.5852 15.4815C37.6181 15.5195 37.6589 15.5501 37.7049 15.5711C37.7509 15.592 37.8009 15.6029 37.8516 15.603H39.6656C39.8049 15.6031 39.9397 15.5541 40.0455 15.4648C40.1514 15.3756 40.2215 15.252 40.243 15.1163L41.3314 8.32301C41.3394 8.27381 41.3365 8.22349 41.3229 8.17551C41.3092 8.12753 41.2851 8.08305 41.2523 8.04513C41.2195 8.00721 41.1788 7.97676 41.1329 7.95589C41.087 7.93501 41.037 7.92421 40.9864 7.92423V7.92423ZM38.1793 11.7873C37.985 12.9212 37.0719 13.6824 35.9072 13.6824C35.3224 13.6824 34.8551 13.4976 34.555 13.1473C34.2574 12.7994 34.1442 12.3042 34.2389 11.7527C34.4203 10.6285 35.3489 9.84241 36.4957 9.84241C37.0676 9.84241 37.5324 10.0297 37.8387 10.383C38.1455 10.74 38.2673 11.2382 38.1793 11.7873V11.7873ZM51.7119 7.92423H49.6882C49.5927 7.92437 49.4988 7.94747 49.4144 7.99151C49.3301 8.03555 49.258 8.09921 49.2042 8.17695L46.4131 12.2291L45.23 8.33513C45.1937 8.21637 45.1195 8.11229 45.0185 8.03828C44.9175 7.96428 44.7951 7.92429 44.6692 7.92423H42.6805C42.6247 7.92408 42.5697 7.93708 42.52 7.96213C42.4703 7.98719 42.4274 8.02359 42.3948 8.06829C42.3623 8.11299 42.3411 8.16471 42.3329 8.21913C42.3247 8.27356 42.3299 8.32912 42.3479 8.3812L44.577 14.8285L42.4813 17.7442C42.4441 17.7959 42.422 17.8567 42.4175 17.92C42.4129 17.9832 42.4262 18.0465 42.4557 18.1028C42.4852 18.1591 42.5299 18.2064 42.5849 18.2393C42.6398 18.2723 42.7029 18.2897 42.7673 18.2897H44.7885C44.8829 18.2898 44.9759 18.2674 45.0595 18.2243C45.1431 18.1812 45.2149 18.1188 45.2687 18.0424L51.9997 8.46665C52.0361 8.41484 52.0575 8.35418 52.0615 8.29124C52.0655 8.2283 52.052 8.16549 52.0223 8.1096C51.9927 8.05372 51.9481 8.0069 51.8933 7.97422C51.8386 7.94155 51.7759 7.92426 51.7119 7.92423V7.92423Z"
                    fill="#022273"
                  />
                  <path
                    d="M58.4118 4.0903H54.2058C54.0667 4.09036 53.9321 4.13934 53.8264 4.22845C53.7207 4.31755 53.6507 4.44092 53.629 4.57636L51.9281 15.2048C51.9202 15.2541 51.9232 15.3044 51.937 15.3524C51.9507 15.4004 51.9748 15.4448 52.0077 15.4827C52.0405 15.5207 52.0813 15.5511 52.1272 15.572C52.1732 15.5928 52.2231 15.6036 52.2737 15.6036H54.4321C54.5295 15.6035 54.6236 15.5691 54.6975 15.5067C54.7715 15.4442 54.8204 15.3578 54.8355 15.263L55.3182 12.2503C55.3397 12.1147 55.4097 11.9912 55.5154 11.902C55.6212 11.8128 55.7558 11.7637 55.895 11.7636H57.2257C59.9965 11.7636 61.5947 10.4424 62.0128 7.82424C62.2016 6.67878 62.0202 5.77878 61.476 5.14848C60.8789 4.45636 59.8194 4.0903 58.4118 4.0903V4.0903ZM58.897 7.97212C58.6677 9.45939 57.5147 9.45939 56.3992 9.45939H55.7652L56.2111 6.68181C56.2238 6.60055 56.2657 6.52648 56.3291 6.47301C56.3925 6.41953 56.4732 6.3902 56.5566 6.3903H56.8475C57.6063 6.3903 58.3233 6.3903 58.6935 6.81696C58.9142 7.07151 58.9813 7.44969 58.897 7.97212V7.97212ZM70.982 7.92424H68.9694C68.8859 7.92401 68.8051 7.95331 68.7417 8.0068C68.6783 8.06029 68.6365 8.13443 68.6238 8.21575L68.5347 8.7709L68.3932 8.56969C67.9572 7.94605 66.9857 7.73757 66.0153 7.73757C63.7899 7.73757 61.8898 9.39878 61.5196 11.7291C61.3278 12.8915 61.6002 14.003 62.2692 14.7782C62.8842 15.4909 63.761 15.7879 64.8058 15.7879C66.5989 15.7879 67.5932 14.6515 67.5932 14.6515L67.5034 15.203C67.4954 15.2524 67.4984 15.303 67.5121 15.3511C67.5259 15.3993 67.5501 15.444 67.5831 15.482C67.6161 15.52 67.657 15.5506 67.7032 15.5715C67.7493 15.5924 67.7995 15.6031 67.8503 15.603H69.6636C69.8029 15.6029 69.9375 15.5539 70.0432 15.4646C70.149 15.3754 70.2189 15.2519 70.2404 15.1164L71.3295 8.32302C71.3372 8.27367 71.334 8.22325 71.3201 8.17524C71.3061 8.12722 71.2818 8.08274 71.2488 8.04485C71.2158 8.00697 71.1749 7.97657 71.1288 7.95575C71.0828 7.93493 71.0327 7.92418 70.982 7.92424V7.92424ZM68.1749 11.7873C67.9818 12.9212 67.0675 13.6824 65.9028 13.6824C65.3192 13.6824 64.8507 13.4976 64.5506 13.1473C64.253 12.7994 64.1411 12.3042 64.2345 11.7527C64.4172 10.6285 65.3444 9.84242 66.4913 9.84242C67.0631 9.84242 67.528 10.0297 67.8343 10.383C68.1423 10.74 68.2641 11.2382 68.1749 11.7873V11.7873ZM73.3562 4.38181L71.6302 15.2048C71.6222 15.2541 71.6253 15.3044 71.639 15.3524C71.6527 15.4004 71.6768 15.4448 71.7097 15.4827C71.7425 15.5207 71.7833 15.5511 71.8293 15.572C71.8752 15.5928 71.9252 15.6036 71.9757 15.6036H73.711C73.9994 15.6036 74.2442 15.3976 74.2885 15.117L75.9906 4.48909C75.9985 4.43982 75.9954 4.38945 75.9817 4.34145C75.968 4.29344 75.9439 4.24893 75.911 4.21098C75.8782 4.17303 75.8374 4.14254 75.7915 4.1216C75.7456 4.10067 75.6956 4.08978 75.645 4.08969H73.7018C73.6184 4.08998 73.5378 4.11954 73.4745 4.17307C73.4112 4.22659 73.3692 4.3006 73.3562 4.38181Z"
                    fill="#167FC4"
                  />
                  <path
                    d="M4.46792 17.6691L4.78952 15.6557L4.07314 15.6394H0.652344L3.02962 0.783017C3.0367 0.737624 3.06009 0.696249 3.09553 0.666435C3.13098 0.63662 3.17611 0.620351 3.22271 0.620593H8.99065C10.9055 0.620593 12.227 1.01332 12.9169 1.78847C13.2404 2.15211 13.4464 2.53211 13.546 2.95029C13.6505 3.38908 13.6524 3.91332 13.5503 4.55271L13.5429 4.59938V5.00908L13.8663 5.18968C14.1133 5.31298 14.3352 5.47977 14.5212 5.68181C14.7979 5.99271 14.9769 6.38787 15.0525 6.85635C15.1306 7.33817 15.1048 7.9115 14.9769 8.56059C14.8293 9.30726 14.5907 9.95756 14.2685 10.4897C13.9842 10.9664 13.602 11.3792 13.1463 11.7018C12.7183 12.0012 12.2098 12.2285 11.6348 12.3739C11.0777 12.517 10.4425 12.5891 9.74577 12.5891H9.29688C8.97589 12.5891 8.66413 12.703 8.41939 12.9073C8.175 13.1137 8.01288 13.3989 7.96189 13.7121L7.92807 13.8933L7.35988 17.4418L7.33406 17.5721C7.32729 17.6133 7.31561 17.6339 7.29839 17.6479C7.28171 17.6613 7.2609 17.6688 7.23936 17.6691H4.46792Z"
                    fill="#022273"
                  />
                  <path
                    d="M14.173 4.64668C14.1558 4.75517 14.1361 4.86608 14.114 4.98002C13.3533 8.82911 10.751 10.1588 7.42732 10.1588H5.73506C5.3286 10.1588 4.98609 10.4497 4.92276 10.8449L4.05633 16.2606L3.81098 17.7958C3.80121 17.8567 3.80494 17.9189 3.82192 17.9783C3.8389 18.0376 3.86872 18.0926 3.90934 18.1395C3.94996 18.1864 4.0004 18.224 4.0572 18.2499C4.114 18.2757 4.1758 18.2891 4.23835 18.2891H7.23977C7.59519 18.2891 7.89712 18.0346 7.95308 17.6891L7.98259 17.5388L8.5477 14.0043L8.58398 13.8103C8.63933 13.4637 8.94187 13.2091 9.29729 13.2091H9.74618C12.6541 13.2091 14.9306 12.0455 15.5959 8.6782C15.8739 7.27153 15.73 6.09699 14.9945 5.27092C14.7614 5.01539 14.483 4.80385 14.173 4.64668V4.64668Z"
                    fill="#167FC4"
                  />
                  <path
                    d="M13.3764 4.33393C13.1335 4.26468 12.8865 4.21063 12.6367 4.17211C12.1431 4.09735 11.6442 4.06148 11.1449 4.06484H6.62397C6.45192 4.06471 6.2855 4.12524 6.15479 4.23551C6.02408 4.34577 5.9377 4.49849 5.91128 4.66605L4.94955 10.6697L4.92188 10.8448C4.95184 10.6537 5.05021 10.4795 5.1992 10.3536C5.3482 10.2278 5.53797 10.1587 5.73418 10.1588H7.42644C10.7501 10.1588 13.3524 8.82847 14.1131 4.97999C14.1358 4.86605 14.1549 4.75514 14.1721 4.64666C13.9714 4.54291 13.7622 4.45594 13.5467 4.38666C13.4902 4.36818 13.4335 4.3506 13.3764 4.33393V4.33393Z"
                    fill="#022273"
                  />
                  <path
                    d="M5.91178 4.66606C5.93798 4.49845 6.02431 4.34567 6.15508 4.23546C6.28586 4.12525 6.45241 4.06493 6.62447 4.06545H11.1454C11.681 4.06545 12.1809 4.1 12.6372 4.17273C12.9459 4.22055 13.2504 4.29208 13.5478 4.38667C13.7723 4.46 13.9808 4.54667 14.1732 4.64667C14.3995 3.22424 14.1714 2.25576 13.391 1.37879C12.5308 0.413333 10.9781 0 8.9913 0H3.22335C2.81751 0 2.47131 0.290909 2.40858 0.686667L0.00609367 15.6958C-0.00509672 15.7654 -0.000839159 15.8367 0.0185735 15.9046C0.0379862 15.9725 0.0720932 16.0355 0.118548 16.0891C0.165004 16.1428 0.222705 16.1859 0.287682 16.2155C0.35266 16.2451 0.423372 16.2605 0.494955 16.2606H4.05595L4.95005 10.6697L5.91178 4.66606V4.66606Z"
                    fill="#022273"
                  />
                </svg>
                <svg
                  width="75"
                  height="16"
                  viewBox="0 0 75 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.4242 9.93676C14.3783 14.2224 10.1296 16.8307 5.93429 15.7619C1.74066 14.6934 -0.812284 10.3525 0.234045 6.06707C1.2794 1.78089 5.5281 -0.82757 9.72222 0.240914C13.9173 1.3094 16.47 5.65083 15.4242 9.93676V9.93676Z"
                    fill="#FCA014"
                  />
                  <path
                    d="M11.2812 6.86122C11.4371 5.79674 10.6437 5.22449 9.559 4.84275L9.91087 3.40077L9.05174 3.18202L8.70917 4.586C8.48331 4.5285 8.25133 4.47426 8.02083 4.42051L8.36585 3.00728L7.5072 2.78853L7.15508 4.23C6.96813 4.1865 6.78461 4.14351 6.60647 4.09826L6.60745 4.09376L5.42262 3.79151L5.19408 4.729C5.19408 4.729 5.83151 4.87824 5.81806 4.88749C6.16602 4.97624 6.2289 5.21149 6.21838 5.39798L5.81756 7.04071C5.84154 7.04696 5.87262 7.05596 5.90688 7.06996C5.87825 7.06271 5.84767 7.05471 5.8161 7.04696L5.25427 9.34818C5.21169 9.45618 5.10378 9.61817 4.86055 9.55667C4.86912 9.56942 4.23608 9.39743 4.23608 9.39743L3.80957 10.4022L4.9276 10.6869C5.13559 10.7402 5.33942 10.7959 5.54007 10.8484L5.18453 12.3069L6.04269 12.5256L6.39481 11.0826C6.62923 11.1476 6.8568 11.2077 7.07947 11.2641L6.72858 12.7004L7.58771 12.9191L7.94326 11.4634C9.40827 11.7466 10.5099 11.6324 10.9736 10.2787C11.3473 9.18868 10.955 8.55994 10.1842 8.14995C10.7455 8.0177 11.1684 7.64046 11.2812 6.86122V6.86122ZM9.31822 9.67342C9.05272 10.7634 7.25639 10.1742 6.67401 10.0264L7.14579 8.09419C7.72817 8.24269 9.5957 8.53669 9.31822 9.67342ZM9.58396 6.84546C9.34171 7.83695 7.8466 7.33321 7.36161 7.20971L7.78934 5.45724C8.27434 5.58074 9.83624 5.81123 9.58396 6.84546Z"
                    fill="white"
                  />
                  <g opacity="0.5">
                    <path
                      d="M22.9464 4.84127C23.5814 4.84127 24.13 4.95752 24.591 5.18576C25.0543 5.41626 25.4365 5.72676 25.7431 6.11725C26.0455 6.50975 26.2706 6.96849 26.416 7.49423C26.5604 8.02147 26.6328 8.58822 26.6328 9.19496C26.6328 10.1269 26.4657 11.0074 26.1282 11.8374C25.7908 12.6687 25.333 13.3896 24.7506 14.0046C24.1687 14.6189 23.4816 15.1031 22.6892 15.4609C21.8981 15.8189 21.038 15.9979 20.1145 15.9979C19.9951 15.9979 19.7852 15.9944 19.4886 15.9881C19.192 15.9819 18.8512 15.9506 18.4694 15.8978C18.0852 15.8431 17.679 15.7621 17.2501 15.6536C16.8214 15.5471 16.4142 15.3979 16.0308 15.2084L19.4595 0.489594L22.5304 0.0033493L21.3028 5.22652C21.5656 5.10552 21.8303 5.01177 22.0946 4.94352C22.3591 4.87627 22.643 4.84127 22.9464 4.84127V4.84127ZM20.3705 13.5089C20.833 13.5089 21.2688 13.3926 21.6781 13.1644C22.0888 12.9359 22.4431 12.6274 22.7399 12.2432C23.0367 11.8572 23.2716 11.4224 23.4429 10.9367C23.6142 10.4509 23.7008 9.94419 23.7008 9.41695C23.7008 8.76921 23.5949 8.26397 23.3837 7.89873C23.1725 7.53498 22.7817 7.35198 22.2143 7.35198C22.0283 7.35198 21.7888 7.38823 21.4917 7.45298C21.1936 7.52173 20.9269 7.66448 20.6879 7.87923L19.3807 13.4261C19.4595 13.4404 19.5292 13.4539 19.5887 13.4666C19.6469 13.4804 19.7113 13.4901 19.7754 13.4969C19.8432 13.5046 19.9207 13.5086 20.0144 13.5086C20.1082 13.5086 20.2254 13.5089 20.3705 13.5089V13.5089Z"
                      fill="#666666"
                    />
                    <path
                      d="M29.8175 15.7161H26.8843L29.3614 5.06701H32.3146L29.8175 15.7161ZM31.2448 3.76953C30.8354 3.76953 30.4642 3.64503 30.1348 3.39553C29.8028 3.14754 29.6384 2.7658 29.6384 2.2513C29.6384 1.96831 29.6946 1.70281 29.8062 1.45231C29.9195 1.20232 30.0676 0.987073 30.253 0.804075C30.4383 0.622578 30.6529 0.477578 30.8966 0.368329C31.1418 0.260831 31.4026 0.207085 31.6806 0.207085C32.0897 0.207085 32.459 0.331583 32.7896 0.581079C33.1189 0.831825 33.2846 1.21357 33.2846 1.72531C33.2846 2.00931 33.2286 2.2758 33.116 2.5258C33.0042 2.77579 32.8561 2.99104 32.6707 3.17403C32.4869 3.35578 32.2703 3.50028 32.0271 3.60853C31.7817 3.71778 31.5218 3.76953 31.2448 3.76953Z"
                      fill="#666666"
                    />
                    <path
                      d="M34.8844 2.41379L37.9565 1.92754L37.2021 5.06649H40.4924L39.8982 7.53595H36.6278L35.7567 11.2609C35.6764 11.5714 35.6309 11.8614 35.6182 12.1309C35.6038 12.4016 35.6373 12.6341 35.7166 12.8299C35.7954 13.0261 35.937 13.1774 36.1426 13.2844C36.3472 13.3931 36.6401 13.4479 37.0242 13.4479C37.3406 13.4479 37.649 13.4171 37.947 13.3561C38.2433 13.2961 38.5436 13.2126 38.8475 13.1034L39.0663 15.4123C38.6698 15.5608 38.2406 15.6886 37.7782 15.7961C37.3149 15.9051 36.7666 15.9576 36.1328 15.9576C35.2215 15.9576 34.5151 15.8193 34.0118 15.5441C33.5091 15.2668 33.1538 14.8881 32.9412 14.4086C32.7315 13.9309 32.6378 13.3801 32.664 12.7596C32.6911 12.1376 32.7829 11.4839 32.9412 10.7954L34.8844 2.41379V2.41379Z"
                      fill="#666666"
                    />
                  </g>
                  <path
                    d="M40.3643 11.4637C40.3643 10.5464 40.5096 9.68145 40.8001 8.87171C41.09 8.06122 41.5077 7.35248 42.0497 6.74424C42.5898 6.139 43.2478 5.6595 44.0222 5.30751C44.793 4.95752 45.6561 4.78102 46.6072 4.78102C47.2026 4.78102 47.7343 4.83852 48.2022 4.95377C48.672 5.07002 49.097 5.22027 49.4815 5.40877L48.4699 7.75873C48.2056 7.64923 47.9313 7.55273 47.6477 7.46523C47.3638 7.37598 47.0174 7.33298 46.6075 7.33298C45.6284 7.33298 44.8545 7.67773 44.2784 8.36496C43.7046 9.0527 43.4156 9.97844 43.4156 11.1397C43.4156 11.8279 43.561 12.3844 43.8527 12.8101C44.1429 13.2359 44.679 13.4476 45.4574 13.4476C45.8416 13.4476 46.2123 13.4066 46.5674 13.3266C46.9251 13.2456 47.241 13.1436 47.5192 13.0231L47.7382 15.4321C47.3673 15.5791 46.9581 15.7118 46.5094 15.8281C46.0596 15.9403 45.5242 15.9986 44.9034 15.9986C44.0839 15.9986 43.3902 15.8761 42.8227 15.6349C42.255 15.3899 41.786 15.0646 41.4165 14.6526C41.045 14.2396 40.7783 13.7574 40.6134 13.2039C40.4484 12.6509 40.3643 12.0699 40.3643 11.4637V11.4637Z"
                    fill="#666666"
                  />
                  <path
                    d="M53.3939 15.9986C52.6938 15.9986 52.0857 15.8896 51.5699 15.6738C51.0556 15.4581 50.6295 15.1554 50.2926 14.7629C49.9552 14.3724 49.7026 13.9096 49.5296 13.3764C49.3566 12.8434 49.2734 12.2532 49.2734 11.6064C49.2734 10.7952 49.4009 9.98419 49.6586 9.17545C49.915 8.36497 50.2955 7.63673 50.7991 6.98949C51.2988 6.34125 51.9152 5.81125 52.641 5.39801C53.366 4.98751 54.1999 4.78102 55.1367 4.78102C55.824 4.78102 56.4289 4.89027 56.9518 5.10601C57.4723 5.32126 57.901 5.62651 58.2399 6.017C58.5752 6.4095 58.8299 6.87024 59.0012 7.40423C59.1737 7.93622 59.2588 8.52796 59.2588 9.1752C59.2588 9.98394 59.1331 10.7949 58.8835 11.6062C58.6336 12.4134 58.2629 13.1434 57.7735 13.7921C57.2851 14.4394 56.6743 14.9691 55.9407 15.3806C55.2081 15.7921 54.3585 15.9986 53.3939 15.9986V15.9986ZM54.8599 7.33323C54.4251 7.33323 54.0406 7.46223 53.7115 7.71697C53.3812 7.97472 53.1037 8.29872 52.88 8.68946C52.6539 9.08195 52.4863 9.50995 52.373 9.97519C52.2607 10.4414 52.2057 10.8822 52.2057 11.3009C52.2057 11.9767 52.3123 12.5029 52.5221 12.8816C52.7347 13.2584 53.1167 13.4479 53.6719 13.4479C54.1082 13.4479 54.4907 13.3199 54.8217 13.0624C55.1501 12.8066 55.4278 12.4824 55.6532 12.0909C55.8778 11.7004 56.0469 11.2712 56.1602 10.8052C56.2711 10.3404 56.3276 9.89719 56.3276 9.4792C56.3276 8.80521 56.2214 8.27772 56.0097 7.89947C55.7983 7.52273 55.4146 7.33323 54.8599 7.33323Z"
                    fill="#666666"
                  />
                  <path
                    d="M62.4557 15.7161H59.52L61.9971 5.06703H64.9518L62.4557 15.7161V15.7161ZM63.8808 3.76955C63.4717 3.76955 63.1007 3.64505 62.7718 3.39556C62.4415 3.14756 62.2756 2.76582 62.2756 2.25133C62.2756 1.96833 62.3326 1.70283 62.4444 1.45233C62.5562 1.20234 62.7053 0.987095 62.8907 0.804098C63.075 0.622601 63.2916 0.477601 63.5348 0.368352C63.7785 0.260854 64.0393 0.207108 64.3163 0.207108C64.7265 0.207108 65.0969 0.331606 65.4268 0.581102C65.7569 0.831848 65.9235 1.21359 65.9235 1.72533C65.9235 2.00933 65.8643 2.27582 65.7535 2.52582C65.6426 2.77582 65.4936 2.99106 65.3088 3.17406C65.1229 3.3558 64.909 3.5003 64.6653 3.60855C64.4196 3.7178 64.1593 3.76955 63.8808 3.76955V3.76955Z"
                    fill="#666666"
                  />
                  <path
                    d="M67.0663 5.55126C67.2889 5.48476 67.5375 5.40476 67.8079 5.31776C68.0793 5.23077 68.3825 5.14977 68.7212 5.07677C69.0561 5.00152 69.4342 4.94052 69.85 4.89327C70.2657 4.84502 70.7394 4.82152 71.2658 4.82152C72.8127 4.82152 73.8791 5.28177 74.4679 6.1995C75.0561 7.11724 75.1579 8.37322 74.7762 9.96519L73.4269 15.7151H70.4744L71.7821 10.0862C71.8619 9.7347 71.9245 9.39495 71.9708 9.06295C72.0175 8.73396 72.0148 8.44397 71.9602 8.19297C71.9081 7.94497 71.7853 7.74197 71.5946 7.58473C71.4011 7.42998 71.1087 7.35223 70.712 7.35223C70.3296 7.35223 69.9405 7.39423 69.5433 7.47523L67.6207 15.7148H64.667L67.0663 5.55126V5.55126Z"
                    fill="#666666"
                  />
                </svg>
              </div>
              <div>
                <div class="relative mb-8">
                  <div
                    class="absolute inset-0 flex items-center"
                    aria-hidden="true"
                  >
                    <div class="w-full border-t border-gray-300"></div>
                  </div>
                  <div class="relative flex justify-start">
                    <span
                      class="pr-3 bg-white text-sm font-medium text-gray-900"
                    >
                      DESCRIPTION
                    </span>
                  </div>
                </div>
                <span class="text-gray-400 text-md"
                  >Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                  Iste magnam esse cumque, qui quam et vel porro a consectetur
                  laudantium doloribus adipisci? Molestias dolores officiis
                  repudiandae deserunt harum, quis porro!</span
                >
              </div>
              <div>
                <div class="relative">
                  <div
                    class="absolute inset-0 flex items-center"
                    aria-hidden="true"
                  >
                    <div class="w-full border-t border-gray-300"></div>
                  </div>
                  <div class="relative flex justify-start">
                    <span
                      class="pr-3 bg-white text-sm font-medium text-gray-900"
                    >
                      ADDITIONAL INFORMATION
                    </span>
                  </div>
                </div>
                <div class="space-y-2 pt-8">
                  <span class="flex items-center space-x-3"
                    ><strong>Color:</strong>
                    <span class="text-gray-400 text-md"
                      >Blue, White, Black, Gray</span
                    ></span
                  >
                  <span class="flex items-center space-x-3"
                    ><strong>Size:</strong>
                    <span class="text-gray-400 text-md">XS, S, M, L</span></span
                  >
                  <span class="flex items-center space-x-3"
                    ><strong>Material:</strong>
                    <span class="text-gray-400 text-md">100% Cotton</span></span
                  >
                </div>
              </div>
              <div>
                <div class="relative">
                  <div
                    class="absolute inset-0 flex items-center"
                    aria-hidden="true"
                  >
                    <div class="w-full border-t border-gray-300"></div>
                  </div>
                  <div class="relative flex justify-start">
                    <span
                      class="pr-3 bg-white text-sm font-medium text-gray-900"
                    >
                      REVIEWS
                    </span>
                  </div>
                </div>
                <div class="flex items-center justify-between pt-8">
                  <a href="#" class="flex items-center">
                    <svg
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      class="w-4 h-4 text-yellow-400"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                      ></path>
                    </svg>
                    <svg
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      class="w-4 h-4 text-yellow-400"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                      ></path>
                    </svg>
                    <svg
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      class="w-4 h-4 text-yellow-400"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                      ></path>
                    </svg>
                    <svg
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      class="w-4 h-4 text-yellow-400"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                      ></path>
                    </svg>
                    <svg
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      class="w-4 h-4 text-yellow-400"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                      ></path>
                    </svg>
                    <span class="ml-3 text-sm text-black">4 Reviews</span>
                  </a>
                  <a href="#" class="flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    <span class="ml-3 text-sm text-black">Write a review</span>
                  </a>
                </div>
                <div class="mt-8 space-y-8">
                  <div class="space-y-4">
                    <div class="flex items-center justify-between">
                      <span class="text-lg font-semibold">Halit Güvenilir</span>
                      <a href="#" class="flex items-center">
                        <span class="mr-3 text-sm text-gray-400"
                          >3 months ago</span
                        >
                        <svg
                          fill="currentColor"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          class="w-4 h-4 text-yellow-400"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                          ></path>
                        </svg>
                        <svg
                          fill="currentColor"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          class="w-4 h-4 text-yellow-400"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                          ></path>
                        </svg>
                        <svg
                          fill="currentColor"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          class="w-4 h-4 text-yellow-400"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                          ></path>
                        </svg>
                        <svg
                          fill="currentColor"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          class="w-4 h-4 text-yellow-400"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                          ></path>
                        </svg>
                        <svg
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          class="w-4 h-4 text-yellow-400"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                          ></path>
                        </svg>
                      </a>
                    </div>
                    <p class="text-gray-500">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Commodi, dicta et! Eveniet, odit eos. Nam facilis
                      repudiandae, quis dolor quaerat vel quia vitae praesentium
                      sapiente assumenda magnam consectetur debitis?
                    </p>
                  </div>
                  <div class="space-y-4">
                    <div class="flex items-center justify-between">
                      <span class="text-lg font-semibold">Merve Güvenilir</span>
                      <a href="#" class="flex items-center">
                        <span class="mr-3 text-sm text-gray-400"
                          >3 week ago</span
                        >
                        <svg
                          fill="currentColor"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          class="w-4 h-4 text-yellow-400"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                          ></path>
                        </svg>
                        <svg
                          fill="currentColor"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          class="w-4 h-4 text-yellow-400"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                          ></path>
                        </svg>
                        <svg
                          fill="currentColor"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          class="w-4 h-4 text-yellow-400"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                          ></path>
                        </svg>
                        <svg
                          fill="currentColor"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          class="w-4 h-4 text-yellow-400"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                          ></path>
                        </svg>
                        <svg
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          class="w-4 h-4 text-yellow-400"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                          ></path>
                        </svg>
                      </a>
                    </div>
                    <p class="text-gray-500">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Commodi, dicta et! Eveniet, odit eos. Nam facilis
                      repudiandae, quis dolor quaerat vel quia vitae praesentium
                      sapiente assumenda magnam consectetur debitis?
                    </p>
                  </div>
                  <div class="space-y-4">
                    <div class="flex items-center justify-between">
                      <span class="text-lg font-semibold">Atlas Güvenilir</span>
                      <a href="#" class="flex items-center">
                        <span class="mr-3 text-sm text-gray-400"
                          >1 days ago</span
                        >
                        <svg
                          fill="currentColor"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          class="w-4 h-4 text-yellow-400"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                          ></path>
                        </svg>
                        <svg
                          fill="currentColor"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          class="w-4 h-4 text-yellow-400"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                          ></path>
                        </svg>
                        <svg
                          fill="currentColor"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          class="w-4 h-4 text-yellow-400"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                          ></path>
                        </svg>
                        <svg
                          fill="currentColor"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          class="w-4 h-4 text-yellow-400"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                          ></path>
                        </svg>
                        <svg
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          class="w-4 h-4 text-yellow-400"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                          ></path>
                        </svg>
                      </a>
                    </div>
                    <p class="text-gray-500">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Commodi, dicta et! Eveniet, odit eos. Nam facilis
                      repudiandae, quis dolor quaerat vel quia vitae praesentium
                      sapiente assumenda magnam consectetur debitis?
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white max-w-screen-2xl mx-auto px-4 py-8">
      <div class="flex flex-wrap space-y-6 lg:space-y-0">
        <div class="w-full lg:w-2/4 lg:pr-6">
          <div class="flex items-center justify-center cursor-pointer">
            <img :src="`${publicPath}unsplash.jpeg`" alt="" />
          </div>
          <div class="flex flex-wrap items-center justify-center space-x-4">
            <span
              class="relative inline-block w-20 h-20 border border-gray-200 rounded-sm cursor-pointer"
            >
              <img :src="`${publicPath}unsplash.jpeg`" alt="" />
              <div
                class="absolute inset-0 bg-black opacity-0 w-full h-full rounded-sm transition-opacity hover:opacity-10"
              ></div>
            </span>
            <span
              class="relative inline-block w-20 h-20 border border-gray-200 rounded-sm cursor-pointer"
            >
              <img :src="`${publicPath}unsplash.jpeg`" alt="" />
              <div
                class="absolute inset-0 bg-black opacity-0 w-full h-full rounded-sm transition-opacity hover:opacity-10"
              ></div>
            </span>
            <span
              class="relative inline-block w-20 h-20 border border-gray-200 rounded-sm cursor-pointer"
            >
              <img :src="`${publicPath}unsplash.jpeg`" alt="" />
              <div
                class="absolute inset-0 bg-black opacity-0 w-full h-full rounded-sm transition-opacity hover:opacity-10"
              ></div>
            </span>
            <span
              class="relative inline-block w-20 h-20 border border-gray-200 rounded-sm cursor-pointer"
            >
              <img :src="`${publicPath}unsplash.jpeg`" alt="" />
              <div
                class="absolute inset-0 bg-black opacity-0 w-full h-full rounded-sm transition-opacity hover:opacity-10"
              ></div>
            </span>
          </div>
        </div>
        <div class="w-full lg:w-2/4">
          <div class="space-y-6">
            <div class="space-y-4">
              <h2 class="text-3xl lg:text-4xl font-semibold leading-10">
                Off-White Odsy-1000 Low-Top Sneakers
              </h2>
              <div class="flex space-x-4">
                <span class="flex items-center">
                  <svg
                    fill="currentColor"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    class="w-4 h-4 text-yellow-400"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                    ></path>
                  </svg>
                  <svg
                    fill="currentColor"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    class="w-4 h-4 text-yellow-400"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                    ></path>
                  </svg>
                  <svg
                    fill="currentColor"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    class="w-4 h-4 text-yellow-400"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                    ></path>
                  </svg>
                  <svg
                    fill="currentColor"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    class="w-4 h-4 text-yellow-400"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                    ></path>
                  </svg>
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    class="w-4 h-4 text-yellow-400"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                    ></path>
                  </svg>
                  <span class="ml-3 text-sm text-gray-400">4 Reviews</span>
                </span>
                <span
                  class="flex items-center text-sm text-green-400 space-x-1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <span>99 orders</span>
                </span>
              </div>
              <div class="flex items-end space-x-2">
                <span class="text-3xl font-semibold">$99.00</span>
                <span class="text-lg text-gray-400">/1pcs</span>
              </div>
            </div>
            <div class="space-y-6">
              <p class="text-gray-500">
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Expedita repellat autem culpa illum rerum architecto tempora
                deserunt excepturi fuga veritatis quia quidem minus ratione quod
                commodi, corrupti hic magnam non.
              </p>
              <ul class="space-y-1">
                <li>
                  <strong class="inline-block w-24">Model</strong>
                  <span>Shoes-12345</span>
                </li>
                <li>
                  <strong class="inline-block w-24">Color</strong>
                  <span>Blue</span>
                </li>
                <li>
                  <strong class="inline-block w-24">Delivery</strong>
                  <span>Turkey, Europe and Usa</span>
                </li>
              </ul>
              <hr />
              <div
                class="flex flex-col sm:flex-row sm:items-center space-y-6 sm:space-y-0 sm:space-x-10"
              >
                <div class="relative z-0 inline-flex shadow-sm rounded-md">
                  <button
                    type="button"
                    class="relative inline-flex items-center px-4 py-4 border-t border-l border-b border-gray-300 rounded-tl-md rounded-bl-md bg-white text-sm font-medium text-gray-500 hover:bg-gray-400 hover:text-white focus:z-10 focus:outline-none focus:ring-1 focus:ring-gray-500 focus:border-gray-500"
                  >
                    <svg
                      class="h-3 w-3"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.5 10H17.5"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                  <input
                    type="text"
                    name="username"
                    id="username"
                    autocomplete="username"
                    class="block w-12 text-gray-500 border border-gray-300 focus:ring-gray-500 focus:border-gray-500 min-w-0 sm:text-sm text-center"
                    value="1"
                  />
                  <button
                    type="button"
                    class="relative inline-flex items-center px-4 py-4 border-t border-r border-b border-gray-300 rounded-tr-md rounded-br-md bg-white text-sm font-medium text-gray-500 hover:bg-gray-400 hover:text-white focus:z-10 focus:outline-none focus:ring-1 focus:ring-gray-500 focus:border-gray-500"
                  >
                    <svg
                      class="h-3 w-3"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.5 10H17.5"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M10 2.5V17.5"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
                <div class="flex items-center space-x-4">
                  <div class="flex items-center">
                    <input
                      id="small"
                      name="size"
                      type="radio"
                      class="focus:ring-blue-600 h-4 w-4 text-blue-800 border-gray-300"
                    />
                    <label
                      for="small"
                      class="ml-3 block text-sm font-medium text-gray-700"
                    >
                      Small
                    </label>
                  </div>
                  <div class="flex items-center">
                    <input
                      id="medium"
                      name="size"
                      type="radio"
                      class="focus:ring-blue-600 h-4 w-4 text-blue-800 border-gray-300"
                    />
                    <label
                      for="medium"
                      class="ml-3 block text-sm font-medium text-gray-700"
                    >
                      Medium
                    </label>
                  </div>
                  <div class="flex items-center">
                    <input
                      id="large"
                      name="size"
                      type="radio"
                      class="focus:ring-blue-600 h-4 w-4 text-blue-800 border-gray-300"
                    />
                    <label
                      for="large"
                      class="ml-3 block text-sm font-medium text-gray-700"
                    >
                      Large
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="space-x-4 mt-10">
            <a
              href="#"
              class="inline-flex items-center justify-center px-6 py-2.5 border-2 border-transparent text-base font-medium rounded-md text-white bg-blue-800 transition transform hover:scale-105 hover:bg-blue-700"
            >
              Buy now
            </a>
            <a
              href="#"
              class="inline-flex items-center justify-center px-6 py-2.5 space-x-2 text-base font-medium rounded-md text-blue-800 border-2 border-blue-800 transition transform hover:scale-105 hover:bg-blue-800 hover:text-white"
            >
              <span>Add to cart</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
    <section>
  <h1 class="sr-only">Checkout</h1>

  <div class="relative mx-auto max-w-screen-2xl">
    <div class="grid grid-cols-1 md:grid-cols-2">
      <div class="py-12 bg-gray-50 md:py-24">
        <div class="max-w-lg px-4 mx-auto lg:px-8">
          <div class="flex items-center">
            <span class="w-10 h-10 bg-blue-900 rounded-full"></span>

            <h2 class="ml-4 font-medium">BambooYou</h2>
          </div>

          <div class="mt-8">
            <p class="text-2xl font-medium tracking-tight">$99.99</p>
            <p class="mt-1 text-sm text-gray-500">For the purchase of</p>
          </div>

          <div class="mt-12">
            <div class="flow-root">
              <ul class="-my-4 divide-y divide-gray-200">
                <li class="flex items-center justify-between py-4">
                  <div class="flex items-start">
                    <img
                      alt="Trainer"
                      src="https://images.unsplash.com/photo-1565299999261-28ba859019bb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80"
                      class="flex-shrink-0 object-cover w-16 h-16 rounded-lg"
                    />

                    <div class="ml-4">
                      <p class="text-sm">Vibrant Trainers</p>

                      <dl class="mt-1 space-y-1 text-xs text-gray-500">
                        <div>
                          <dt class="inline">Color:</dt>
                          <dd class="inline">Blue</dd>
                        </div>

                        <div>
                          <dt class="inline">Size:</dt>
                          <dd class="inline">UK 10</dd>
                        </div>
                      </dl>
                    </div>
                  </div>

                  <div>
                    <p class="text-sm">
                      $49.99
                      <small class="text-gray-500">x1</small>
                    </p>
                  </div>
                </li>

                <li class="flex items-center justify-between py-4">
                  <div class="flex items-start">
                    <img
                      alt="Lettuce"
                      src="https://images.unsplash.com/photo-1640958904159-51ae08bd3412?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1771&q=80"
                      class="flex-shrink-0 object-cover w-16 h-16 rounded-lg"
                    />

                    <div class="ml-4">
                      <p class="text-sm">Lettuce</p>

                      <dl class="mt-1 space-y-1 text-xs text-gray-500">
                        <div>
                          <dt class="inline">Size:</dt>
                          <dd class="inline">Big</dd>
                        </div>
                      </dl>
                    </div>
                  </div>

                  <div>
                    <p class="text-sm">
                      $25
                      <small class="text-gray-500">x2</small>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="py-12 bg-white md:py-24">
        <div class="max-w-lg px-4 mx-auto lg:px-8">
          <form class="grid grid-cols-6 gap-4">
            <div class="col-span-3">
              <label class="block mb-1 text-sm text-gray-600" for="first_name">
                First Name
              </label>

              <input
                class="rounded-lg shadow-sm border-gray-200 w-full text-sm p-2.5"
                type="text"
                id="frst_name"
              />
            </div>

            <div class="col-span-3">
              <label class="block mb-1 text-sm text-gray-600" for="last_name">
                Last Name
              </label>

              <input
                class="rounded-lg shadow-sm border-gray-200 w-full text-sm p-2.5"
                type="text"
                id="last_name"
              />
            </div>

            <div class="col-span-6">
              <label class="block mb-1 text-sm text-gray-600" for="email">
                Email
              </label>

              <input
                class="rounded-lg shadow-sm border-gray-200 w-full text-sm p-2.5"
                type="email"
                id="email"
              />
            </div>

            <div class="col-span-6">
              <label class="block mb-1 text-sm text-gray-600" for="phone">
                Phone
              </label>

              <input
                class="rounded-lg shadow-sm border-gray-200 w-full text-sm p-2.5"
                type="tel"
                id="phone"
              />
            </div>

            <fieldset class="col-span-6">
              <legend class="block mb-1 text-sm text-gray-600">
                Card Details
              </legend>

              <div class="-space-y-px bg-white rounded-lg shadow-sm">
                <div>
                  <label class="sr-only" for="card-number">Card Number</label>

                  <input
                    class="border-gray-200 relative rounded-t-lg w-full focus:z-10 text-sm p-2.5 placeholder-gray-400"
                    type="text"
                    name="card-number"
                    id="card-number"
                    placeholder="Card number"
                  />
                </div>

                <div class="flex -space-x-px">
                  <div class="flex-1">
                    <label class="sr-only" for="card-expiration-date">
                      Expiration Date
                    </label>

                    <input
                      class="border-gray-200 relative rounded-bl-lg w-full focus:z-10 text-sm p-2.5 placeholder-gray-400"
                      type="text"
                      name="card-expiration-date"
                      id="card-expiration-date"
                      placeholder="MM / YY"
                    />
                  </div>

                  <div class="flex-1">
                    <label class="sr-only" for="card-cvc">CVC</label>

                    <input
                      class="border-gray-200 relative rounded-br-lg w-full focus:z-10 text-sm p-2.5 placeholder-gray-400"
                      type="text"
                      name="card-cvc"
                      id="card-cvc"
                      placeholder="CVC"
                    />
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="col-span-6">
              <legend class="block mb-1 text-sm text-gray-600">
                Billing Address
              </legend>

              <div class="-space-y-px bg-white rounded-lg shadow-sm">
                <div>
                  <label class="sr-only" for="country">Country</label>

                  <select
                    class="border-gray-200 relative rounded-t-lg w-full focus:z-10 text-sm p-2.5"
                    id="country"
                    name="country"
                    autocomplete="country-name"
                  >
                    <option>England</option>
                    <option>Wales</option>
                    <option>Scotland</option>
                    <option>France</option>
                    <option>Belgium</option>
                    <option>Japan</option>
                  </select>
                </div>

                <div>
                  <label class="sr-only" for="postal-code">
                    ZIP/Post Code
                  </label>

                  <input
                    class="border-gray-200 relative rounded-b-lg w-full focus:z-10 text-sm p-2.5 placeholder-gray-400"
                    type="text"
                    name="postal-code"
                    id="postal-code"
                    autocomplete="postal-code"
                    placeholder="ZIP/Post Code"
                  />
                </div>
              </div>
            </fieldset>

            <div class="col-span-6">
              <button
                class="rounded-lg bg-black text-sm p-2.5 text-white w-full block"
                type="submit"
              >
                Pay Now
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
<!--
  This component uses @tailwindcss/forms

  yarn add @tailwindcss/forms
  npm install @tailwindcss/forms

  plugins: [require('@tailwindcss/forms')]
-->

<!--
@layer components {
  .no-spinner {
    -moz-appearance: textfield;
  }

  .no-spinner::-webkit-outer-spin-button,
  .no-spinner::-webkit-inner-spin-button {
    margin: 0;
    -webkit-appearance: none;
  }
}
-->

<section>
  <div class="relative max-w-screen-xl px-4 py-8 mx-auto">
    <div class="grid items-start grid-cols-1 gap-8 md:grid-cols-2">
      <div class="grid grid-cols-2 gap-4 md:grid-cols-1">
        <img
          alt="Les Paul"
          src="https://images.unsplash.com/photo-1456948927036-ad533e53865c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80"
          class="object-cover w-full aspect-square rounded-xl"
        />

        <div class="grid grid-cols-2 gap-4 lg:mt-4">
          <img
            alt="Les Paul"
            src="https://images.unsplash.com/photo-1456948927036-ad533e53865c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80"
            class="object-cover w-full aspect-square rounded-xl"
          />

          <img
            alt="Les Paul"
            src="https://images.unsplash.com/photo-1456948927036-ad533e53865c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80"
            class="object-cover w-full aspect-square rounded-xl"
          />

          <img
            alt="Les Paul"
            src="https://images.unsplash.com/photo-1456948927036-ad533e53865c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80"
            class="object-cover w-full aspect-square rounded-xl"
          />

          <img
            alt="Les Paul"
            src="https://images.unsplash.com/photo-1456948927036-ad533e53865c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80"
            class="object-cover w-full aspect-square rounded-xl"
          />
        </div>
      </div>

      <div class="sticky top-0">
        <strong
          class="border border-blue-600 rounded-full tracking-wide px-3 font-medium py-0.5 text-xs bg-gray-100 text-blue-600"
        >
          Pre Order
        </strong>

        <div class="flex justify-between mt-8">
          <div class="max-w-[35ch]">
            <h1 class="text-2xl font-bold">
              Fun Product That Does Something Cool
            </h1>

            <p class="mt-0.5 text-sm">Highest Rated Product</p>

            <div class="flex mt-2 -ml-0.5">
              <svg
                class="w-5 h-5 text-yellow-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                />
              </svg>

              <svg
                class="w-5 h-5 text-yellow-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                />
              </svg>

              <svg
                class="w-5 h-5 text-yellow-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                />
              </svg>

              <svg
                class="w-5 h-5 text-yellow-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                />
              </svg>

              <svg
                class="w-5 h-5 text-gray-200"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                />
              </svg>
            </div>
          </div>

          <p class="text-lg font-bold">$119.99</p>
        </div>

        <details class="relative mt-4 group">
          <summary class="block">
            <div>
              <div class="prose max-w-none group-open:hidden">
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa
                  veniam dicta beatae eos ex error culpa delectus rem tenetur,
                  architecto quam nesciunt, dolor veritatis nisi minus
                  inventore, rerum at recusandae?
                </p>
              </div>

              <span
                class="mt-4 text-sm font-medium underline cursor-pointer group-open:absolute group-open:bottom-0 group-open:left-0 group-open:mt-0"
              >
                Read More
              </span>
            </div>
          </summary>

          <div class="pb-6 prose max-w-none">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa
              veniam dicta beatae eos ex error culpa delectus rem tenetur,
              architecto quam nesciunt, dolor veritatis nisi minus inventore,
              rerum at recusandae?
            </p>

            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat
              nam sapiente nobis ea veritatis error consequatur nisi
              exercitationem iure laudantium culpa, animi temporibus non! Maxime
              et quisquam amet. A, deserunt!
            </p>
          </div>
        </details>

        <form class="mt-8">
          <fieldset>
            <legend class="mb-1 text-sm font-medium">Color</legend>

            <div class="flow-root">
              <div class="flex flex-wrap -m-0.5">
                <label for="color_tt" class="cursor-pointer p-0.5">
                  <input
                    type="radio"
                    name="color"
                    id="color_tt"
                    class="sr-only peer"
                  />

                  <span
                    class="inline-block px-3 py-1 text-xs font-medium border rounded-full group peer-checked:bg-black peer-checked:text-white"
                  >
                    Texas Tea
                  </span>
                </label>

                <label for="color_fr" class="cursor-pointer p-0.5">
                  <input
                    type="radio"
                    name="color"
                    id="color_fr"
                    class="sr-only peer"
                  />

                  <span
                    class="inline-block px-3 py-1 text-xs font-medium border rounded-full group peer-checked:bg-black peer-checked:text-white"
                  >
                    Fiesta Red
                  </span>
                </label>

                <label for="color_cb" class="cursor-pointer p-0.5">
                  <input
                    type="radio"
                    name="color"
                    id="color_cb"
                    class="sr-only peer"
                  />

                  <span
                    class="inline-block px-3 py-1 text-xs font-medium border rounded-full group peer-checked:bg-black peer-checked:text-white"
                  >
                    Cobalt Blue
                  </span>
                </label>
              </div>
            </div>
          </fieldset>

          <fieldset class="mt-4">
            <legend class="mb-1 text-sm font-medium">Size</legend>

            <div class="flow-root">
              <div class="flex flex-wrap -m-0.5">
                <label for="size_xs" class="cursor-pointer p-0.5">
                  <input
                    type="radio"
                    name="size"
                    id="size_xs"
                    class="sr-only peer"
                  />

                  <span
                    class="inline-flex items-center justify-center w-8 h-8 text-xs font-medium border rounded-full group peer-checked:bg-black peer-checked:text-white"
                  >
                    XS
                  </span>
                </label>

                <label for="size_s" class="cursor-pointer p-0.5">
                  <input
                    type="radio"
                    name="size"
                    id="size_s"
                    class="sr-only peer"
                  />

                  <span
                    class="inline-flex items-center justify-center w-8 h-8 text-xs font-medium border rounded-full group peer-checked:bg-black peer-checked:text-white"
                  >
                    S
                  </span>
                </label>

                <label for="size_m" class="cursor-pointer p-0.5">
                  <input
                    type="radio"
                    name="size"
                    id="size_m"
                    class="sr-only peer"
                  />

                  <span
                    class="inline-flex items-center justify-center w-8 h-8 text-xs font-medium border rounded-full group peer-checked:bg-black peer-checked:text-white"
                  >
                    M
                  </span>
                </label>

                <label for="size_l" class="cursor-pointer p-0.5">
                  <input
                    type="radio"
                    name="size"
                    id="size_l"
                    class="sr-only peer"
                  />

                  <span
                    class="inline-flex items-center justify-center w-8 h-8 text-xs font-medium border rounded-full group peer-checked:bg-black peer-checked:text-white"
                  >
                    L
                  </span>
                </label>

                <label for="size_xl" class="cursor-pointer p-0.5">
                  <input
                    type="radio"
                    name="size"
                    id="size_xl"
                    class="sr-only peer"
                  />

                  <span
                    class="inline-flex items-center justify-center w-8 h-8 text-xs font-medium border rounded-full group peer-checked:bg-black peer-checked:text-white"
                  >
                    XL
                  </span>
                </label>
              </div>
            </div>
          </fieldset>

          <div class="flex mt-8">
            <div>
              <label for="quantity" class="sr-only">Qty</label>

              <input
                type="number"
                id="quantity"
                min="1"
                value="1"
                class="w-12 py-3 text-xs text-center border-gray-200 rounded [-moz-appearance:_textfield] [&::-webkit-outer-spin-button]:m-0 [&::-webkit-inner-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
              />
            </div>

            <button
              type="submit"
              class="block px-5 py-3 ml-3 text-xs font-medium text-white bg-green-600 rounded hover:bg-green-500"
            >
              Add to Cart
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
<div class="bg-white py-6 sm:py-8 lg:py-12">
  <div class="max-w-screen-lg px-4 md:px-8 mx-auto">
    <div class="grid md:grid-cols-2 gap-8">
      <!-- images - start -->
      <div class="space-y-4">
        <div class="bg-gray-100 rounded-lg overflow-hidden relative">
          <img src="https://images.unsplash.com/flagged/photo-1571366992942-be878c7b10c0?auto=format&q=75&fit=crop&w=600" loading="lazy" alt="Photo by Himanshu Dewangan" class="w-full h-full object-cover object-center" />

          <span class="bg-red-500 text-white text-sm tracking-wider uppercase rounded-br-lg absolute left-0 top-0 px-3 py-1.5">sale</span>
        </div>

        <div class="grid grid-cols-2 gap-4">
          <div class="bg-gray-100 rounded-lg overflow-hidden">
            <img src="https://images.unsplash.com/flagged/photo-1571366992791-2ad2078656cb?auto=format&q=75&fit=crop&w=250" loading="lazy" alt="Photo by Himanshu Dewangan" class="w-full h-full object-cover object-center" />
          </div>

          <div class="bg-gray-100 rounded-lg overflow-hidden">
            <img src="https://images.unsplash.com/flagged/photo-1571366992968-15b65708ee76?auto=format&q=75&fit=crop&w=250" loading="lazy" alt="Photo by Himanshu Dewangan" class="w-full h-full object-cover object-center" />
          </div>
        </div>
      </div>
      <!-- images - end -->

      <!-- content - start -->
      <div class="md:py-8">
        <!-- name - start -->
        <div class="mb-2 md:mb-3">
          <span class="inline-block text-gray-500 mb-0.5">Fancy Brand</span>
          <h2 class="text-gray-800 text-2xl lg:text-3xl font-bold">Pullover with pattern</h2>
        </div>
        <!-- name - end -->

        <!-- rating - start -->
        <div class="flex items-center mb-6 md:mb-10">
          <div class="flex gap-0.5 -ml-1">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-gray-300" viewBox="0 0 20 20" fill="currentColor">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
          </div>

          <span class="text-gray-500 text-sm ml-2">4.2</span>

          <a href="#" class="text-indigo-500 hover:text-indigo-600 active:text-indigo-700 text-sm font-semibold transition duration-100 ml-4">view all 47 reviews</a>
        </div>
        <!-- rating - end -->

        <!-- color - start -->
        <div class="mb-4 md:mb-6">
          <span class="inline-block text-gray-500 text-sm md:text-base font-semibold mb-3">Color</span>

          <div class="flex flex-wrap gap-2">
            <span class="w-8 h-8 bg-gray-800 border ring-2 ring-offset-1 ring-gray-800 rounded-full transition duration-100"></span>
            <button type="button" class="w-8 h-8 bg-gray-500 border ring-2 ring-offset-1 ring-transparent hover:ring-gray-200 rounded-full transition duration-100"></button>
            <button type="button" class="w-8 h-8 bg-gray-200 border ring-2 ring-offset-1 ring-transparent hover:ring-gray-200 rounded-full transition duration-100"></button>
            <button type="button" class="w-8 h-8 bg-white border ring-2 ring-offset-1 ring-transparent hover:ring-gray-200 rounded-full transition duration-100"></button>
          </div>
        </div>
        <!-- color - end -->

        <!-- size - start -->
        <div class="mb-8 md:mb-10">
          <span class="inline-block text-gray-500 text-sm md:text-base font-semibold mb-3">Size</span>

          <div class="flex flex-wrap gap-3">
            <button type="button" class="w-12 h-8 flex justify-center items-center bg-white hover:bg-gray-100 active:bg-gray-200 text-gray-800 text-sm font-semibold text-center border rounded-md transition duration-100">XS</button>
            <button type="button" class="w-12 h-8 flex justify-center items-center bg-white hover:bg-gray-100 active:bg-gray-200 text-gray-800 text-sm font-semibold text-center border rounded-md transition duration-100">S</button>
            <span class="w-12 h-8 flex justify-center items-center bg-indigo-500 text-white text-sm font-semibold text-center border border-indigo-500 rounded-md cursor-default">M</span>
            <button type="button" class="w-12 h-8 flex justify-center items-center bg-white hover:bg-gray-100 active:bg-gray-200 text-gray-800 text-sm font-semibold text-center border rounded-md transition duration-100">L</button>
            <span class="w-12 h-8 flex justify-center items-center bg-white text-gray-400 text-sm font-semibold text-center border border-transparent rounded-md cursor-not-allowed">XL</span>
          </div>
        </div>
        <!-- size - end -->

        <!-- price - start -->
        <div class="mb-4">
          <div class="flex items-end gap-2">
            <span class="text-gray-800 text-xl md:text-2xl font-bold">$15.00</span>
            <span class="text-red-500 line-through mb-0.5">$30.00</span>
          </div>

          <span class="text-gray-500 text-sm">incl. VAT plus shipping</span>
        </div>
        <!-- price - end -->

        <!-- shipping notice - start -->
        <div class="flex items-center text-gray-500 gap-2 mb-6">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
          </svg>

          <span class="text-sm">2-4 day shipping</span>
        </div>
        <!-- shipping notice - end -->

        <!-- buttons - start -->
        <div class="flex gap-2.5">
          <a href="#" class="inline-block flex-1 sm:flex-none bg-indigo-500 hover:bg-indigo-600 active:bg-indigo-700 focus-visible:ring ring-indigo-300 text-white text-sm md:text-base font-semibold text-center rounded-lg outline-none transition duration-100 px-8 py-3">Add to cart</a>

          <a href="#" class="inline-block bg-gray-200 hover:bg-gray-300 focus-visible:ring ring-indigo-300 text-gray-500 active:text-gray-700 text-sm md:text-base font-semibold text-center rounded-lg outline-none transition duration-100 px-4 py-3">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
            </svg>
          </a>
        </div>
        <!-- buttons - end -->

        <!-- description - start -->
        <div class="mt-10 md:mt-16 lg:mt-20">
          <div class="text-gray-800 text-lg font-semibold mb-3">Description</div>

          <p class="text-gray-500">
            This is a section of some simple filler text, also known as placeholder text. It shares some characteristics of a real written text but is random or otherwise generated. It may be used to display a sample of fonts or generate text for testing.<br /><br />

            This is a section of some simple filler text, also known as placeholder text. It shares some characteristics of a real written text but is random or otherwise generated.
          </p>
        </div>
        <!-- description - end -->
      </div>
      <!-- content - end -->
    </div>
  </div>
</div>

</section>
</template>

<script>
export default {
    name: "TestPage",
    components: {},
    data() {
        return {
            publicPath: process.env.BASE_URL
        }
    },
};
</script>
